
import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';
import { _HttpClient } from '@delon/theme';
import { NzModalService } from 'ng-zorro-antd';
import { HttpService, JwtService, MethodsService, PageService, SetService, GeneralPipe, LayoutService, FormControlService } from 'ngx-block-core';
import { min } from 'moment';
import { selectSize2 } from "../../../data/data";
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { NzNotificationService, NzMessageService } from 'ng-zorro-antd';
import * as XLSX from 'xlsx';
import * as Excel from "exceljs/dist/exceljs.min.js";
import * as fs from 'file-saver';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { fromEvent as observableFromEvent, of as observableOf } from 'rxjs';
import { ReplaySubject, Subscription } from 'rxjs';
import { BarcodeMaterial } from './BarcodeMaterial';

import * as JSZip from 'mjszip';

interface Child {
  child: Child;
  [key: string]: any;
}
@Component({
  selector: 'app-sucu01-data0010001',
  templateUrl: './sucu01-data0010001.component.html',
  styles: [
    `
    .custom-filter-dropdown {
      padding: 8px;
      border-radius: 6px;
      background: #fff;
      box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
    }


    .highlight {
      color: #f50;
    }
      .editable-cell {
        position: relative;
      }

      .editable-cell-input-wrapper,
      .editable-cell-text-wrapper {
        padding-right: 24px;
      }

      .editable-cell-text-wrapper {
        padding: 5px 24px 5px 5px;
      }

      .editable-cell-icon,
      .editable-cell-icon-check {
        position: absolute;
        right: 0;
        width: 20px;
        cursor: pointer;
      }

      .editable-cell-icon {
        line-height: 18px;
        display: none;
      }

      .editable-cell-icon-check {
        line-height: 28px;
      }

      .editable-cell:hover .editable-cell-icon {
        display: inline-block;
      }

      .editable-cell-icon:hover,
      .editable-cell-icon-check:hover {
        color: #108ee9;
      }

      .editable-add-btn {
        margin-bottom: 8px;
      }

      nz-form-item {
        margin-bottom: 0px;
      }
      .td-white-space {
        white-space: pre-wrap;
      }

  `
  ]
})
export class Sucu01Data0010001Component implements OnInit {
  getExportData$: ReplaySubject<{ last: boolean }> = new ReplaySubject<{ last: boolean }>();
  getExportDataSub: Subscription
  @Input() httpUrls = {
    tableData: {
      needChange: true,
      url: "/system/tableData",
      // puturl:"/system/tableData",
      name2: "tableData",
    },
    autoexcel: {
      needChange: true,
      url: "/export/autoexcel",
      name2: "export",
    },
    workflowrunList: {
      needChange: false,
      url: "/csysworkflowrun/listCondition",
      name2: "",
    },
    logicalDeleteData: {
      needChange: true,
      url: "/system/logicalDeleteData",
      name2: "logicalDeleteTableData",
    },
    dynamicSql: {
      needChange: false,
      url: "/system/dynamicSql",
      name2: "",
    },
    dynamicProcedure: {
      needChange: false,
      url: "/system/dynamicProcedure",
      name2: "proData",
    },
  }
  displayData = [];
  nzTotal = [];
  loading = false;
  isEdit: { [key: string]: any } = {};
  isRowEdit: { [key: string]: any } = {};
  columnStatu: { [key: string]: any } = {};
  valueChange: { [key: string]: any } = {};
  footer = {};
  isNeedFooter = false;
  alreadySet = false;
  geval = eval;
  previewImage: string | undefined = '';
  picIsVisible = false;
  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() sets = {
    "blockCode": "sucublock1",
    "blockId": "",
    "blockName": "表格",
    "layoutId": "",
    "blockType": "table",
    "blockChildType": '',
    "versionCode": 24,
    "events": [
      {
        label: "刷新",
        value: "simpleSearch",
        data: {}
      },
      {
        label: "搜索刷新",
        value: "search",
        data: {
          setParams: ["tablefields", 'searchType', '附加设置']
        }
      }
    ],
    "styles": {
      "nzPageSizeOptions": [8, 16, 32, 50, 80],
      "nzPageSize": 8,

      "nzShowPagination": true,
      "nzShowQuickJumper": true,
      "nzShowCheckbox": false,
      "nzOneCheckbox": false,
      "nzBordered": true,
      "nzScroll": false,
      "nzScrollValueY": 400,
      "nzScrollcolumn": false,
      "nzScrollValueX": 1500,

      "nzHeadHeight": 50,
      "nzlineHeight": 1,
      "nzTitle": "",
      "nzSize": "small",
      "nzTimer": {
        "nzUsed": false,
        "nzTime": 10,
      },
      "nzOperations": {
        "nzOperationsPosition": "front",
        "nzOperationsGroup": [],
        "nzOperationWidth": "100",
      },

      "footerName": "统计",

    },
    "datas": {
      "nzSearch": {
        merge: false,
        "nzUsed": true,
        "searchColumn": [
          // {
          //   field:"",
          //   name:"=",//搜索方式
          //   type:"",
          //   instruction:"",
          //   valueType:"static",
          //   valueKey:"",//场景值KEY
          //   value1:"",
          //   value2:""
          // }
        ],
        "sortColumn": [
          // {
          //   name:"",
          //   type:""
          // }
        ]
      },
      "events": ['change', 'test'],
      "nzNeedOrganize": false,
      "nzNeedRelation": false,
      "nzTableName": "",
      "sysFields": {
      },
      nzIsDelete: true,
      "searchColumn": [
      ],
      "searchMastColumn": [
      ],
      "virtualColumn": [],
      "virtualColumn2": [],
      "nzVirtual": [],
      "nzVirtualData": {},
      "nzRelation": [],
      "allColumn": [],
      "showColumn": [
      ],
      "tableGroup": [],
      "ColumnData": {

      },
      nzRowspanLinkage: [],
      nzRowspanfollow: [],
      nzCalculate: [],
      nzCalculateData: {

      },
      other: {
        nzNeedExport: false
      }
      ,
      jumpLog: '',
      nzProcedure: {
        nzProcedureIsNeed: false,
        nzProcedureTriggerPosition: "default",
        nzProcedureName: "",
        nzProcedureView: "",
        nzServiceParam: [],
        nzServiceParamDetail: { "sequ": 1 }

      },
      nzSysLog: [],
      nzCustom: {
        nzUsed: false,
        nzUrl: '',
        nzHeadType: ''
      },
      jichengRightId: ''
    }
  };

  //定时器
  private nzTimer;

  constructor(private optionservice: HttpService,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute, private notification: NzNotificationService,
    private message: NzMessageService, public generalPipe: GeneralPipe,
    private location: Location, private methodsService: MethodsService, public jwtService: JwtService, private formControlService: FormControlService,
    public setService: SetService, private pageService: PageService, private modalService: NzModalService, private router: Router, private layoutService: LayoutService) {

  }

  pzListening() {

    this.setService.initEvent(this.blockid, 'pz');
    this.setService.pzEvents[this.blockid].subscribe(

      data => {
        console.log('pzListening', data['type'])
        switch (data['type']) {
          case 'simpleSearch':
            this.translationData = {};
            this.getTranslationData();
            this.searchData(true);
            break;
          case 'clear':
            this.displayData = [];
            break;
          case 'nzTimertrue':
            if (!this.nzTimer) {
              this.nzTimer = setInterval(() => {
                this.searchData();
              }, this.sets['styles']['nzTimer']['nzTime'] * 1000)
            }
            break;
          case 'nzTimerfalse':
            if (this.nzTimer) {
              clearInterval(this.nzTimer);
              this.nzTimer = null;
            }
            // this.setService.onReLoadbBlock(this.layoutid)
            break;
          case 'allColumn':
            this.getAllColumn();
            // this.setService.onReLoadbBlock(this.layoutid)
            break;
          case 'onClick1_save':
            this.onClick1_save(data['datas']);
            break;
          default:
            break;
        }
      }
    )


  }
  /** 搜索后，需执行的事件 */
  searchEvent = {};
  Listening() {
    console.log('Listening', this.blockid)
    this.setService.initEvent(this.blockid);

    this.setService.events[this.blockid].subscribe(
      data => {
        console.log('Listening-body', JSON.stringify(data));
        switch (data['type']) {

          case 'editData':
            this.editData(data['datas']);
            break;
          case 'deleteMore':
            this.deleteMore(data['datas']);
            break;
          case 'search':
            this.searchEvent = {};
            if (typeof data['sets'] != "undefined" && data['sets'] != "") {

              const setArr = (data['sets'] + "").split(",")
              setArr.forEach(element => {
                switch (element) {
                  case "checkall":
                    this.searchEvent[element] = true
                    break;

                  default:
                    break;
                }
              });

            }
            console.log("search", JSON.stringify(data['datas']))
            if (this.sets.datas.nzSearch.merge) {
              this.searchMap = Object.assign(this.searchMap, data['datas'])
            } else {
              this.searchMap = data['datas'];
            }
            if (typeof data['status'] != "undefined")
              this.searchData(true, this.searchMap, data['status'], this.searchEvent);
            else
              this.searchData(true, this.searchMap, { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, this.searchEvent);
            break;
          case 'simpleSearch':
            if (data['datas']['reset'] !== undefined) this.searchData(data['datas']['reset']);
            else this.searchData(true);


            break;
          //关联查询
          case 'relationSearch':

            let targetdata = data['datas'];

            //从setservice中获取条件信息
            console.log("监听数据", this.setService.publicDatas[targetdata.targetblock]['relationSearch'])
            let searchMap = {};
            this.setService.publicDatas[targetdata.targetblock]['relationSearch'].forEach(element => {
              let item = [{
                "name": "=",
                "value1": element.value
              }]
              searchMap[element.relationName] = item
            });


            this.searchMap = searchMap;
            console.log("组装完成数据", this.searchMap)
            this.searchData(true);
            break;

          case 'jumpPage':
            this.jumpPage(data['datas']);
            break;
          case 'export':
            this.exportExcel(data['datas'])
            this.doExportBlockid = data['datas'].blockid;
            console.log('exportExcel doExportBlockid', this.doExportBlockid)
            break;
          case 'frontExport':
            this.exportData = data['datas'];
            this.doExportBlockid = this.exportData.blockid;
            this.frontExport();
            break;
          default:
            break;
        }


      }
    )


  }
  getSearchMapBylayout(layoutid) {
    if (layoutid != '') {
      const formData = this.setService.pageDatas['form_data_' + layoutid];
      const form = this.setService.pageDatas['form_' + layoutid];
      console.log("formdata", formData, layoutid)
      if (formData != undefined) {
        return this.getSearchMap(this.formControlService.getSearchBodyT(formData, form)[0][this.blockid]);
      } else {
        return this.searchMap;
      }
    } else {
      return this.searchMap;
    }
  }
  exportExcel(eventData) {
    //  获取搜索条件
    let searchMap = this.getSearchMapBylayout(eventData.layoutid);

    this.loading = true;
    //字段筛选
    const list = this.sets.datas.searchColumn.filter(value => {
      if (this.sets.datas.virtualColumn.indexOf(value['name']) < 0 && this.sets.datas.virtualColumn2.indexOf(value['name']) < 0 &&
        this.sets.datas.showColumn.indexOf(value['name']) >= 0) return true;
      return false;
    })
    console.log("exportExcel", JSON.stringify(list))
    //中文名
    let headerNameArray = [], columnNameArray = []
    list.forEach(element => {
      headerNameArray.push(this.sets.datas.ColumnData[element['name']].Relname)
      columnNameArray.push(element['name'])
    });
    //
    console.log("headerNameArray", JSON.stringify(headerNameArray))
    let body = {

      "exportExcelName": eventData.nzExportExcelName,
      "sheetNameArray": [eventData.nzSheetNameArray],
      "headerNameArray": headerNameArray,
      "columnNameArray": columnNameArray,
      "tableDataBean": {
        "tableColumn": list,
        "tableName": this.sets.datas.nzTableName,
        "pageSize": 0,
        "tableSort": this.tableSort,
        "searchMap": searchMap,
        "engineMap": {
        },
        "deleteFlag": [
        ],
        "nowPage": "1"
      }
    }
    console.log("body", JSON.stringify(body));
    for (let index = 0; index < this.sets.datas.searchMastColumn.length; index++) {
      const mastColumn = this.sets.datas.searchMastColumn[index];
      if (!body.tableDataBean.searchMap[mastColumn]) {
        this.message.create('error', '缺少查询条件:' + this.sets.datas.ColumnData[mastColumn]['Relname']);
        this.setService.sendEvent(eventData.blockid, 'nzLoadingOk');

        this.loading = false;
        return;
      }
    }
    this.optionservice.postHttp(this.httpUrls.autoexcel.url, body).subscribe(
      (data: any) => {
        this.loading = false;
        console.log("autoexcel" + JSON.stringify(data.data))
        if (data.data.data !== undefined && data.data.data !== "") {
          window.open(data.data.data);
        } else {
          console.log("autoexcel", this.jwtService.getUserResourceUrl() + data.data.stringData)
          if (data.data.stringData !== undefined && data.data.stringData !== "") {
            window.open(this.jwtService.getUserResourceUrl() + data.data.stringData);
          } else {
            this.message.create('error', `不存在数据，无法导出`);
          }

        }
        this.setService.sendEvent(eventData.blockid, 'nzLoadingOk');
      }
      , (err) => {
        this.message.create('error', ``);
        this.setService.sendEvent(eventData.blockid, 'nzLoadingOk');
      });
  }
  setData = []
  getAllColumn() {
    this.allColumn.splice(0, this.allColumn.length)
    this.allColumn.push({
      label: "无",
      value: ""
    })
    for (const key in this.sets.datas.ColumnData) {
      if (this.sets.datas.ColumnData.hasOwnProperty(key)) {
        this.allColumn.push(
          {
            label: this.sets.datas.ColumnData[key].Relname,
            value: key
          }
        )
      }
    }
  }
  allColumn = []
  setDataInit() {
    let nzValueSourceAttributes = [
      {
        name: 'input',
        inputs: {
          nzText: '名称',
          nzKeys: ['name']
        },
        value: '名称',
        rule: '@text@日志+@index1@'
      },
      {
        name: 'input',
        inputs: {
          nzText: '描述',
          nzKeys: ['desc'],
          nzType: 'textarea',
          nzPopContent: '可配置动态参数：@param1@',
          nzReadOnly: true
        },
        value: '记录被删除',
        rule: ''
      }
    ]
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzTable' },
              {
                name: 'switch',
                inputs: {
                  nzText: "后端导出 : ", nzKeys: ['datas', 'other', 'nzNeedExport']
                }
              },
              {
                name: 'select',
                inputs: { nzText: "删除标记 : ", nzKeys: ['datas', 'sysFields', 'isDelete'], nzData: this.allColumn, nzPopContent: "注意再次编辑表格时可能会覆盖" },
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "启用删除标记 : ", nzKeys: ['datas', 'nzIsDelete']
                }
              },
              { name: "nzDrawerLog", inputs: { nzType: "pop" } },
              {
                name: 'list',
                inputs: { nzText: "系统日志 : ", titleKey: 'name', nzKeys: ['datas', 'nzSysLog'], attributes: nzValueSourceAttributes },

              },

            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "分页 : ", nzKeys: ['styles', 'nzShowPagination']
                }
              },
              {
                name: 'nzPageSizeOptions',
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "分页跳转 : ", nzKeys: ['styles', 'nzShowQuickJumper']
                }
              },
              {
                name: 'input',
                inputs: {
                  nzText: "表头名称 : ", nzKeys: ['styles', 'nzTitle']
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "可选框 : ", nzKeys: ['styles', 'nzShowCheckbox']
                }
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "单选 : ", nzKeys: ['styles', 'nzOneCheckbox']
                }
              },

              {
                name: 'switch',
                inputs: {
                  nzText: "列边框 : ", nzKeys: ['styles', 'nzBordered']
                }
              },
              {
                name: 'nzScroll',

              },
              {
                name: 'number',
                inputs: {
                  nzText: "行间距 : ", nzKeys: ['styles', 'nzlineHeight'], nzStyle: [0, 3, 0.1]
                }
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize2 }
              },
              {
                name: 'nzTimer'
              },
              {
                name: 'select',
                inputs: { nzText: "集成右绑定 : ", nzKeys: ['datas', 'jichengRightId'], nzData: this.setService.getBlock('table', "*") },
              },
              {
                name: 'switch',
                inputs: {
                  nzText: "合并条件 : ", nzKeys: ['datas', 'nzSearch', 'merge']
                }
              },
            ]
          },


        ]
      },
      {
        tabName: '查询功能',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzSearchMap', inputs: { searchMastColumn: true } },
              { name: 'nzTableStatistical' },
              {
                name: 'switch',
                inputs: {
                  nzText: "自定义模式 : ", nzKeys: ['datas', 'nzCustom', 'nzUsed']
                }
              },


              {
                name: 'input',
                inputs: {
                  nzText: "自定义接口 : ", nzKeys: ['datas', 'nzCustom', 'nzUrl']
                }
              },
              {
                name: 'select',
                inputs: { nzText: "自定义表头 : ", nzKeys: ['datas', 'nzCustom', 'nzHeadType'], nzData: [{ value: 'did', label: 'did' }] },
              },
            ]
          },
        ]
      },
      {
        tabName: '操作组',
        datas: [
          {
            type: 'styles',
            data: [
              { name: 'nzOperations' },
            ]
          }
        ]
      },
      {
        tabName: '业务存储',
        datas: [
          {
            type: 'datas',
            data: [

              {
                name: 'nzProcudure',
                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail }
              },
              {
                name: 'nzServiceParam',
                inputs: { nzProcedure: this.sets.datas.nzProcedure, nzServiceParam: this.sets.datas.nzProcedure.nzServiceParam, nzServiceParamDetail: this.sets.datas.nzProcedure.nzServiceParamDetail, nzNeedProcedure: true }
              },
            ]
          },
        ]
      },
    ]

  }
  autoUpdate() {

    if (this.sets.versionCode < 11) {
      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        this.sets.datas.ColumnData[key]['formatType'] = "";
      }
      this.sets.datas['nzRowspanfollow'] = []

      this.sets.versionCode = 11;
    }

    if (this.sets.versionCode < 12) {
      this.sets.datas['nzCalculate'] = []
      this.sets.datas['nzCalculateData'] = {}
      this.sets.versionCode = 12;
    }
    if (this.sets.versionCode < 13) {

      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        this.sets.datas.ColumnData[key]['ellipsisLength'] = 0;
      }
      this.sets.versionCode = 13;
    }
    if (this.sets.versionCode < 14) {
      for (const key in this.sets.datas.ColumnData) {
        //编辑查重
        this.sets.datas.ColumnData[key]['rowspanLinkage'] = true;
      }
      this.sets.versionCode = 14;
    }
    if (this.sets.versionCode < 15) {
      this.sets.datas['other'] = {
        nzNeedExport: false
      }
      this.sets.versionCode = 15;
    }
    if (this.sets.versionCode < 16) {
      this.sets.datas['nzIsDelete'] = true;
      this.sets.versionCode = 16;
    }
    if (this.sets.versionCode < 17) {
      this.sets.datas['jumpLog'] = '';
      this.sets.versionCode = 17;
    }
    if (this.sets.versionCode < 18) {
      this.sets.styles['nzOneCheckbox'] = false;
      this.sets.versionCode = 18;
    }

    if (this.sets.versionCode < 19) {
      if (typeof this.sets.datas.nzProcedure == "undefined") {
        this.sets.datas['nzProcedure'] = {
          nzProcedureIsNeed: false,
          nzProcedureTriggerPosition: "default",
          nzProcedureName: "",
          nzProcedureView: "",
          nzServiceParam: [],
          nzServiceParamDetail: { "sequ": 1 }
        }
      }
      this.sets.versionCode = 19;
    }
    if (this.sets.versionCode < 20) {
      if (typeof this.sets.datas.nzRowspanLinkage == "undefined") {
        this.sets.datas.nzRowspanLinkage = [];
      }
      if (typeof this.sets.datas.nzRowspanfollow == "undefined") {
        this.sets.datas.nzRowspanfollow = [];
      }
      this.sets.versionCode = 20;
    }
    if (this.sets.versionCode < 21) {
      if (typeof this.sets.datas.nzSysLog == "undefined") {
        this.sets.datas.nzSysLog = [];
      }
      this.sets.versionCode = 21;
    }
    if (this.sets.versionCode < 22) {
      if (typeof this.sets.datas.searchMastColumn == "undefined") {
        this.sets.datas['searchMastColumn'] = [];
      }
      this.sets.versionCode = 22;
    }
    if (this.sets.versionCode < 23) {
      if (typeof this.sets.datas.searchMastColumn == "undefined") {
        this.sets.datas['searchMastColumn'] = [];
      }
      this.sets.versionCode = 23;
    }
    if (this.sets.versionCode < 24) {
      if (typeof this.sets.datas.nzCustom == "undefined") {
        this.sets.datas.nzCustom = {
          nzUsed: false,
          nzUrl: '',
          nzHeadType: ''
        }
      }
      this.sets.versionCode = 24;
    }



    // "nzScroll": false,
    // "nzScrollValueY": 400,
    // "nzScrollcolumn": false,
    // "nzScrollValueX": 1500,


  }
  ngOnInit(): void {
    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.getAllColumn();
        this.autoUpdate();
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening();
        this.setService.blockPublicSets[this.blockid + "Urls"] = this.httpUrls;
        // this.setService.setPublicStatus(this.httpUrls,this.blockid,"Urls");
        console.log("Urlstable", JSON.stringify(this.setService.blockPublicSets));
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
        this.autoUpdate();
      }
    }
    console.log("getUrl", JSON.stringify(this.httpUrls));
    console.log("sysFields", JSON.stringify(this.sets.datas.sysFields));
    this.pageService.pageBlockDatas[this.blockid] = {};


    this.Listening();
    this.searchMap = {
    };
    /** 查询之前设置自定义 */
    this.setNzCustom();
    this.tableSort = [];
    if (this.sets.datas.nzTableName != "") {
      if (this.sets.datas.nzSearch.nzUsed) {
        this.searchData();
      }

    }

    if (this.sets['styles']['nzOperations']['nzOperationsGroup'].length <= 3) {
      this.myContext = this.sets['styles']['nzOperations']['nzOperationsGroup'];
    }
    else {
      this.myContext = this.sets['styles']['nzOperations']['nzOperationsGroup'].filter((value, index) => index < 2);
      this.moreOperations = this.sets['styles']['nzOperations']['nzOperationsGroup'].filter((value, index) => index >= 2);
    }
    if (this.sets['styles']['nzTimer']['nzUsed']) {
      this.nzTimer = setInterval(() => {
        this.searchData();
      }, this.sets['styles']['nzTimer']['nzTime'] * 1000)
    }
    this.initFrom();
    //翻译准备
    this.getTranslationData();
  }
  setNzCustomChildData(list: any[], startIndex: number, child: Child, level: number, PRO_BAR_CODE?: string): number {
    for (const key in child) {
      if (key !== 'child' && Object.prototype.hasOwnProperty.call(child, key)) {
        if (PRO_BAR_CODE && PRO_BAR_CODE !== key) continue;
        if (this.levelMax < level) this.levelMax = level;
        const childData: BarcodeMaterial[] = child[key];
        const columnName1 = 'upNo' + level;
        const columnName2 = 'did' + level;



        if (!this.sets.datas.showColumn.includes(columnName1)) {
          this.sets.datas.showColumn.push(columnName1);
          this.sets.datas.ColumnData[columnName1] = Object.assign({}, this.sets.datas.ColumnData["UP_NO"]);
          this.sets.datas.ColumnData[columnName1].baseId = '0';
          this.sets.datas.showColumn.push(columnName2);
          this.sets.datas.ColumnData[columnName2] = Object.assign({}, this.sets.datas.ColumnData["DID"]);
          this.sets.datas.ColumnData[columnName2].baseId = '0';
        }
        const item = list[startIndex];
        const sourceItem = Object.assign({}, item);
        // 添加当前层
        for (let childindex = 0; childindex < childData.length; childindex++) {
          const childItem = childData[childindex];
          if (childindex === 0) {
            item[columnName1] = childItem.upNo;
            item[columnName2] = childItem.did;
          } else {
            const child = childData[childindex];
            list.splice(startIndex + 1, 0, Object.assign({}, sourceItem));
            list[startIndex + 1][columnName1] = child.upNo;
            list[startIndex + 1][columnName2] = child.did;
            startIndex++;
          }
          // 检测是否存在下阶子项
          const nextPRO_BAR_CODE = childItem.upNo;
          if (child.child && child.child[nextPRO_BAR_CODE]) {
            startIndex = this.setNzCustomChildData(list, startIndex, child.child, level + 1, nextPRO_BAR_CODE);
          }

        }



      }

    }
    return startIndex;

  }
  levelMax = 0;
  setNzCustomData(data: any) {
    this.levelMax = 0;
    if (!this.sets.datas.nzCustom.nzUsed) return;
    const list: any[] = data.data.list;
    switch (this.sets.datas.nzCustom.nzHeadType) {
      case 'did':
        const extraData: { [key: string]: Child } = data.extraData;
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          const PRO_BAR_CODE = item['PRO_BAR_CODE'];
          const UP_NO = item['UP_NO'];
          const child = extraData[PRO_BAR_CODE + ',' + UP_NO]['child'];
          if (!child) continue;
          index = this.setNzCustomChildData(list, index, child, 1);
        }
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          for (let i = 1; i <= this.levelMax; i++) {
            const columnName1 = 'upNo' + i;
            const columnName2 = 'did' + i;
            if (!item[columnName1]) {
              item[columnName1] = "";
            }
            if (!item[columnName2]) {
              item[columnName2] = "";
            }
          }
        }
        if (this.levelMax === 0) {
          this.setNzCustom();
        }
        // key PRO_BAR_CODE,UP_NO 
        // PRO_BAR_CODE 主板SN 
        // UP_NO:上料序列 主板SN上的料对应的SN
        console.log('新表格data', list, JSON.stringify(list));
        break;

      default:
        break;
    }
  }
  setNzCustom() {
    if (!this.sets.datas.nzCustom.nzUsed) return;
    let showColumn = [];

    for (let index = 0; index < this.sets.datas.showColumn.length; index++) {
      const element = this.sets.datas.showColumn[index];
      if (this.sets.datas.ColumnData[element]['baseId'] === '0') {
        this.sets.datas.showColumn.splice(index, 1);
        index--;
      }
    }

    if (this.static) {
      this.httpUrls.tableData.url = '/' + this.sets.datas.nzCustom.nzUrl;

    } else {
      this.httpUrls.tableData.url = 'http://localhost:8080/' + this.sets.datas.nzCustom.nzUrl;
    }
  }
  translationData = {};
  /** 获取动态翻译数据 */
  getTranslationData() {
    this.sets.datas.showColumn.forEach(columnName => {
      this.translationData[columnName] = {
        used: false,
        data: {}
      };
      const columnData = this.sets.datas.ColumnData[columnName];
      if (columnData['translationSql'] !== undefined && columnData['translationSql'] !== null && columnData['translationSql'] !== '') {
        if (columnData['translationSql'].indexOf('VALUE') > 0 && columnData['translationSql'].indexOf('LABEL') > 0) {
          let body = {
            // 
            // "dynamicSql": 'select test001_id as value from t_test001 where test001_id=80',
            "dynamicSql": this.pageService.replaceParam(this.jwtService.replaceUser(columnData['translationSql']), this.blockid),
            "pageSize": 0,
            "nowPage": 0,
            "paramMap": [],
            "tableSort": [],
            "searchMap": {
            }
          }
          this.optionservice.postHttp(this.httpUrls.dynamicSql.url, body).subscribe(
            (data: any) => {
              console.log('getTranslationData-sqldata', data.data.list)
              if (data.data.list.length > 0) {
                data.data.list.forEach(element => {
                  this.translationData[columnName].data[element.VALUE] = element.LABEL;
                });
                this.translationData[columnName].used = true;
              }
              console.log('getTranslationData-translationData', this.translationData)

            })
        }
      }
    });
  }
  //销毁组件时清除定时器  
  ngOnDestroy() {
    console.log("ngOnDestroy注销");
    if (this.nzTimer) {
      clearInterval(this.nzTimer);
    }
    this.setService.deleteEvent(this.blockid);
    if (!this.static)
      this.setService.deleteEvent(this.blockid, 'pz')
    if (this.getExportDataSub) {
      this.getExportDataSub.unsubscribe();
    }
  }


  //
  pageIndex = 1;

  //选择框
  allChecked = false;
  indeterminate = false;

  refreshStatus(row?): void {
    if (row !== undefined && this.sets.styles.nzOneCheckbox) {
      //取消其他选中项
      this.checkAll(false);

      //选中当前选中行
      this.displayData[row].checked = true;
    }
    const allChecked = this.displayData.filter(value => !value.disabled).every(value => value.checked === true);
    this.pageService.pageBlockDatas[this.blockid]['checkValue'] = this.displayData.filter(value => value.checked);

    const allUnChecked = this.displayData.filter(value => !value.disabled).every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);

  }

  checkAll(value: boolean): void {
    this.displayData.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  relationSearch(row) {

    //取消其他选中项
    this.checkAll(false);

    //选中当前选中行
    this.displayData[row].checked = true;
    this.refreshStatus();
    console.log("关联查询", this.sets.datas.nzRelation.length, this.sets.datas.nzRelation)

    if (this.sets.datas.nzRelation.length > 0) {
      let searchData = [];

      let checkedList = this.displayData.filter(value => value.checked);
      let sceneitem;

      checkedList.forEach(checkelement => {

        sceneitem = checkelement

      });

      this.sets.datas.nzRelation.forEach(element => {
        if (element.nzRelationIsNeed) {
          let blockid;
          //组装数据

          element.nzRelationParam.forEach(subelement => {

            let item = {
              relationName: subelement.target,
              value: sceneitem[subelement.source]

            }
            blockid = element.nzRelationBlock;
            searchData.push(item)

          });

          this.setService.publicDatas[this.blockid] = {
            relationSearch: searchData
          }
          const datas = {
            "targetblock": this.blockid,
          }
          console.log("关联查询-发送", datas)

          this.setService.sendEvent(blockid, "relationSearch", datas)

        }
      });
    }


  }
  //批量删除
  deleteMore(dateSets) {
    let checkedList = this.displayData.filter(value => value.checked);
    if (checkedList.length > 0) {
      if (dateSets['isShow']) {
        this.modalService.confirm({
          nzTitle: dateSets['title'],
          nzContent: dateSets['content'],
          nzOnOk: () => this.delete(checkedList)
        });
      } else {
        this.delete(checkedList)
      }

    } else {
      this.modalService.info({
        nzTitle: "提示",
        nzContent: "请勾选删除项"
      });
    }

  }

  //单条数据编辑
  editData(dateSets) {

    if (!this.static) {//配置环境

      this.modalService.info({
        nzTitle: "提示",
        nzContent: "请前往生产环境测试"
      });

    } else {//生成环境
      console.log("编辑数据", dateSets)
      let checkedList = this.displayData.filter(value => value.checked);
      console.log("选中长度", checkedList.length);
      //组装场景值数据
      let queryParams = {};
      if (checkedList.length > 0) {

        dateSets['nzSenceJson'].forEach(element => {
          //当前场景值字段
          console.log("场景值字段", element)

          let sceneitem = "";
          checkedList.forEach(checkelement => {

            console.log("遍历数据", checkelement)
            console.log("遍历数据-->", checkelement[element['columnName']])
            sceneitem = sceneitem + checkelement[element['columnName']] + ",";

          });

          sceneitem = sceneitem.substring(0, sceneitem.length - 1);

          queryParams[element['virtualName']] = sceneitem;

        });

      }

      console.log("场景值组装完成", queryParams)


      if (checkedList.length == 1) {
        // switch (dateSets['type']) {
        //   case 'self':

        //     this.router.navigate([dateSets['pageRoute']], {
        //       queryParams
        //     });
        //     break;
        //   case 'new':
        //     window.open(dateSets.pageRoute, '_blank')

        //     break;
        //   case 'pop':


        //     break;

        //   default:
        //     break;
        // }




      } else if (checkedList.length > 1) {
        //批量编辑

      } else {

        this.modalService.info({
          nzTitle: "提示",
          nzContent: "请勾选编辑项"
        });
      }


    }

  }


  //单条数据编辑
  jumpPage(dateSets) {
    if (dateSets['type'] === 'setValue') {
      let checkedList = this.displayData.filter(value => value.checked);
      if (checkedList.length === 1) {

        dateSets['nzSenceJson'].forEach(element => {

          checkedList.forEach(checkelement => {
            if (element.blockid !== undefined && element.blockid !== '')
              this.setService.sendEvent(element.blockid, "linkagesetValue", { value: checkelement[element['columnName']] })
          });



        });

      } else {
        this.modalService.info({
          nzTitle: "提示",
          nzContent: "请勾选一条记录"
        });
      }
      return;
    }
    if (dateSets['type'] === 'closeValue') {
      let checkedList = this.displayData.filter(value => value.checked);
      let data = {};
      if (checkedList.length === 1) {

        dateSets['nzSenceJson'].forEach(element => {

          checkedList.forEach(checkelement => {
            data[element.name] = checkelement[element['columnName']];
          });
        });
        console.log("关闭", this.setService.pageDatas['table_modal']['acceptBlockId'], data)
        if (this.setService.pageDatas['table_modal']['acceptBlockId'] !== undefined && this.setService.pageDatas['table_modal']['acceptBlockId'] !== '')
          this.setService.sendEvent(this.setService.pageDatas['table_modal']['acceptBlockId'], "setValues", data);
        this.layoutService.isVisible = false;
      } else {
        this.modalService.info({
          nzTitle: "提示",
          nzContent: "请勾选一条记录"
        });
      }
      return;
    }

    if (!this.static) {//配置环境

      console.log('dateSets', dateSets)
      this.modalService.info({
        nzTitle: "提示",
        nzContent: "请前往生产环境测试"
      });

    } else {//生成环境
      console.log("编辑数据", dateSets)
      let checkedList = this.displayData.filter(value => value.checked);
      console.log("选中长度", checkedList.length);
      //组装场景值数据
      let queryParams = {};
      if (checkedList.length > 0) {

        dateSets['nzSenceJson'].forEach(element => {
          //当前场景值字段
          console.log("场景值字段", element)

          let sceneitem = "";
          checkedList.forEach(checkelement => {

            console.log("遍历数据", checkelement)
            console.log("遍历数据-->", checkelement[element['columnName']])
            sceneitem = sceneitem + checkelement[element['columnName']] + ",";

          });

          sceneitem = sceneitem.substring(0, sceneitem.length - 1);

          queryParams[element['virtualName']] = sceneitem;

        });

      }
      if (typeof dateSets['nzServiceParam'] != "undefined") {
        dateSets['nzServiceParam'].forEach(param => {
          queryParams[dateSets['nzServiceParamDetail'][param]['urlName']] = this.pageService.getServiceParam(dateSets['nzServiceParamDetail'][param], this.activatedRoute);
        });
      }


      console.log("场景值组装完成", queryParams)

      //判断类型 none：无 single：单条 multiple：多条
      switch (dateSets['mode']) {

        case 'none':
          this.goRouter(dateSets, queryParams);

          break;

        case 'single':
          if (checkedList.length < 1) {

            this.modalService.info({
              nzTitle: "提示",
              nzContent: "请勾选记录项"
            });
          } else if (checkedList.length == 1) {

            this.goRouter(dateSets, queryParams);

          } else if (checkedList.length > 1) {

            this.modalService.info({
              nzTitle: "提示",
              nzContent: "请勾选一条记录"
            });
          }

          break;

        case 'multiple':
          if (checkedList.length < 1) {
            this.modalService.info({
              nzTitle: "提示",
              nzContent: "请勾选记录项"
            });

          } else if (checkedList.length >= 1) {

            this.goRouter(dateSets, queryParams);
          }
          break;

        default:

          break;


      }




    }

  }


  goRouter(dateSets, queryParams) {

    switch (dateSets['type']) {
      case 'self':
        console.log("跳转参数设置", dateSets['pageRoute'], queryParams)
        this.pageService.setRouteParams(dateSets['pageRoute'], queryParams);
        this.router.navigate([dateSets['pageRoute']], {
          queryParams
        });
        break;
      case 'new':
        window.open(dateSets.pageRoute, '_blank')

        break;
      case 'pop':
        //开启弹框

        //处理路由
        let handleRouter = dateSets['pageRoute'];
        console.log("路由", handleRouter);
        let routeRootpath = handleRouter.substr(0, handleRouter.lastIndexOf('/'));
        let componentName = handleRouter.substr(handleRouter.lastIndexOf('/') + 1, handleRouter.length);

        console.log("根路径", routeRootpath);
        console.log("组件名称", componentName);
        //设置弹框标题
        this.layoutService.nzTitle = dateSets['modalTitle'];
        //设置弹框宽度
        this.layoutService.nzWidth = dateSets['modalWidth'];

        //设置弹窗service
        let modaldata = {
          isNeedRefresh: false,
          blockid: this.blockid,
          jumpLog: this.sets.datas.jumpLog,
          acceptBlockId: dateSets['acceptBlockId']

        }
        this.setService.pageDatas['table_modal'] = modaldata;


        //获取当前路由地址
        console.log("当前路由地址", this.location.path());
        //将当前路由信息存储进service

        this.layoutService.nzRoutePath = this.location.path();
        this.pageService.setRouteParams(dateSets['pageRoute'], queryParams);
        this.router.navigate([routeRootpath, { outlets: { modal: componentName } }], {
          queryParams
        });
        //primary:'fullscreen',

        // this.router.navigate(['/fullscreen', { outlets: { modal: 'testmodal' } }], {
        //   queryParams
        // });


        this.layoutService.isVisible = true;



        break;
      case 'innerout':
        //组装参数
        this.pageService.setRouteParams(dateSets['pageRoute'], queryParams);
        this.router.navigate([dateSets['pageRoute']], {
          queryParams
        });

        break;
      case 'newout':
        //组装参数
        console.log("参数列表", queryParams)

        let newPageRoute = dateSets.pageRoute;
        //普通接口风格
        if (dateSets['pageType'] == "3") {

        }
        //restful风格
        else if (dateSets['pageType'] == "4") {

          //拼接参数
          for (const key in queryParams) {
            if (queryParams.hasOwnProperty(key)) {
              const element = queryParams[key];
              newPageRoute = newPageRoute + "/" + element

            }
          }

        }
        console.log("路径", newPageRoute);
        // window.open(dateSets.pageRoute, '_blank')
        //授权地址
        let routelink = "http://172.16.8.107:8090/fullscreen/auth-login";
        routelink = routelink + "?userId=" + this.jwtService.getCurrentUser()['csysUserId'] + "&userName=" + this.jwtService.getCurrentUser()['csysUserUsername'] + "&authOpenid=" + this.jwtService.getCurrentUser()['csysUserOpenId'] + "&redirect_uri=" + newPageRoute
        //routelink = routelink + "?userId=" + this.jwtService.getCurrentUser()['cySysBaseUserId'] + "&userName=" + this.jwtService.getCurrentUser()['cySysBaseUserUsername'] + "&authOpenid=" + this.jwtService.getCurrentUser()['cySysBaseUserOpenid'] + "&redirect_uri="+newPageRoute
        window.open(routelink, '_blank')

        break;
      default:
        break;
    }
  }

  /**
   * 查询表格事件
   */
  searchTable(data) {
    console.log("searchMap\n" + JSON.stringify(data));
    // let searchMap = {};
    // for (const key in data) {
    //   if (data.hasOwnProperty(key)) {
    //     const fieldMap = data[key];
    //     searchMap[key] = [];
    //     fieldMap.forEach(element => {
    //       searchMap[key].push({
    //         name: element['name'],
    //         value1: element['value1'],
    //         value2: element['value2'],
    //         type: element['type'],
    //         format: element['format'],
    //       });
    //     });


    //   }
    // }
    // console.log("searchMap\n" + JSON.stringify(searchMap));
    this.searchMap = data;
    this.searchData(true);
  }
  //编辑
  isSpinning = false;
  updateMap = [];
  primaryMap = [];

  finishEdit(key: string, index: string): void {
    this.isSpinning = true;
    this.updateOneFieldDate(key, this.displayData[index][key], index, false, "finishEdit");
  }
  startEdit(key: string, index: string): void {
    this.isEdit[index + "-" + key] = true;
  }


  /* 自动合并列 **/
  autoRowspanData = [];
  autoRowspanDataCopy = [];

  getSearchMap(searchMap) {
    console.log('searchMap', JSON.stringify(searchMap))
    if (typeof searchMap == "undefined") searchMap = JSON.parse(JSON.stringify(this.searchMap));
    console.log('searchMap0', JSON.stringify(searchMap))
    console.log('searchMap123');
    console.log("sysFields:" + JSON.stringify(this.sets['datas']['sysFields']));
    // for (const key in searchMap) {
    //   if (Object.prototype.hasOwnProperty.call(searchMap, key)) {
    //     const element = searchMap[key];
    //     for (let index = 0; index < element.length; index++) {
    //       const condition = element[index];
    //       if ((!condition.value1 && condition.value1 !== 0) && !condition.value2) {
    //         if (element.length === 1) {
    //           delete searchMap[key];
    //         } else {
    //           element.splice(index, 1);
    //           index--;
    //         }
    //       }
    //     }

    //   }
    // }

    let clearFlag = {}
    //1.默认条件设置
    this.sets.datas.nzSearch.searchColumn.forEach(element => {

      let body = {
        "name": element.name,
        "type": "",
        "instruction": "",
        "value1": element.value1,
        "value2": ""
      }
      console.log("element", JSON.stringify(element))
      if (element.valueType == "dynamic") {

      } else if (element.valueType == "url") {
        if (element.value1 === 'date') {
          body.type = 'dateformat'
          body.instruction = 'yyyy-mm-dd hh24:mi:ss'
        }
        body['value1'] = this.pageService.getRouteParams(this.activatedRoute, element['valueKey']);
      }

      if (typeof searchMap[element.field] == "undefined") {
        console.log("searchMap undefined", JSON.stringify(searchMap))
        searchMap[element.field] = [body]
      } else {

        if (element.level == 'high') {
          if (typeof clearFlag[element.name] == "undefined") {
            delete searchMap[element.field];
            searchMap[element.field] = [body]
          } else {
            searchMap[element.field].push(body);
          }

        } else {
          searchMap[element.field].push(body);
        }
      }
      if (typeof clearFlag[element.name] == "undefined")
        clearFlag[element.name] = true;
    });
    console.log('searchMap最终', JSON.stringify(searchMap));
    return searchMap;
  }
  getSortMap() {
    //2.默认排序设置
    let oldSort = []
    this.tableSort.forEach(element => {
      oldSort.push(element.name);
    })
    let frontData = [], endData = []
    this.sets.datas.nzSearch.sortColumn.forEach(element => {
      let index = oldSort.indexOf(element.field);
      if (index < 0) {
        //未有，根据优先级插入
        if (element.level == 'high') {
          frontData.push(
            {
              name: element.field,
              value: element.type
            }
          )
        } else {
          endData.push(
            {
              name: element.field,
              value: element.type
            }
          )
        }
      } else {
        console.log("已存在", index, oldSort, element, this.tableSort)
        //已有，高优先级调整位置，低优先级不管
        if (element.level == 'high') {
          this.tableSort.splice(index, 1);
          oldSort = []
          this.tableSort.forEach(element => {
            oldSort.push(element.name);
          })
          frontData.push(
            {
              name: element.field,
              value: element.type
            }
          )
        } else {
          this.tableSort[index].value = element.type;
        }
        console.log("已存在2", index, oldSort, element)
      }
    })
    this.tableSort = [...frontData, ...this.tableSort, ...endData]
  }
  dealExcelFormat(olddata) {
    const data = JSON.parse(JSON.stringify(olddata));
    data.forEach(element => {
      for (const name in this.formatHead) {
        const format = this.formatHead[name];
        console.log('dealExcelFormat', element[name], name, element, format, this.formatHead)
        if (typeof element[name] != 'undefined') {
          element[name] = this.generalPipe.transform(element[name], format.type, format.format)
        }
        console.log('dealExcelFormatend', name, element[name])

      }
    })
    return data;
  }
  /**
   * 处理虚拟字段
   * @param data 接口原始数据
   */
  dealVirtualColumn(data, checkResult, isExport = false) {
    console.log('dealVirtualColumn', this.exportMergeData, this.headIndex)
    this.autoRowspanDataCopy = [];
    /* 直通统计数据 **/
    let YieldTPYData = {
      used: false,
      date: "",
      output: "",
      input: "",
      yield: "",
      name: "",
    };

    if (this.sets.datas.nzCalculate.indexOf('TPY') >= 0) {
      YieldTPYData.name = this.sets.datas.nzCalculateData['TPY']['dataArray'][0]['value'];
      YieldTPYData.yield = this.sets.datas.nzCalculateData['TPY']['dataArray'][1]['value'];
      YieldTPYData.input = this.sets.datas.nzCalculateData['TPY']['dataArray'][2]['value'];
      YieldTPYData.output = this.sets.datas.nzCalculateData['TPY']['dataArray'][3]['value'];
      YieldTPYData.date = this.sets.datas.nzCalculateData['TPY']['dataArray'][4]['value'];
      YieldTPYData.used = true;
    }

    let planYieldData = {
      used: false,
      yield: "",
      standardhournum: "",
      number: "",
      standardtime: "",
      totaltime: "",
    };
    if (this.sets.datas.nzCalculate.indexOf('planYield') >= 0) {
      planYieldData.yield = this.sets.datas.nzCalculateData['planYield']['dataArray'][0]['value'];
      planYieldData.standardhournum = this.sets.datas.nzCalculateData['planYield']['dataArray'][1]['value'];
      planYieldData.number = this.sets.datas.nzCalculateData['planYield']['dataArray'][2]['value'];
      planYieldData.standardtime = this.sets.datas.nzCalculateData['planYield']['dataArray'][3]['value'];
      planYieldData.totaltime = this.sets.datas.nzCalculateData['planYield']['dataArray'][4]['value'];
      planYieldData.used = true;
    }
    /* 不计算直通的下标 **/
    let notcheckindex = -1;
    let res = [];
    for (let index = 0; index < data.data['list'].length; index++) {
      // console.log("indexindex", index, data.data['list'].length, notcheckindex)
      const dataitem = data.data['list'][index];
      checkResult.push({})
      let rowspanDataItem = {};

      this.sets['datas']['virtualColumn'].forEach(element => {
        dataitem[element] = ""

      });
      this.sets['datas']['virtualColumn2'].forEach(element => {
        dataitem[element] = this.sets.datas.ColumnData[element]['virtualData']
      });

      for (let showColumnindex = 0; showColumnindex < this.sets['datas']['showColumn'].length; showColumnindex++) {
        const element = this.sets['datas']['showColumn'][showColumnindex];
        checkResult[index][element] = {
          result: false,
          color: '',
          icon: '',
          change: ['', '']
        }

        /* 自动合并列计算**/
        if (typeof rowspanDataItem[element] == "undefined") {
          if (index != 0) {

            if (this.sets.datas['nzRowspanLinkage'].indexOf(element) >= 0 || this.sets.datas['nzRowspanfollow'].indexOf(element) >= 0) {
              if (this.sets.datas['nzRowspanLinkage'].indexOf(element) >= 0) {
                /*联合检测 **/
                this.nzRowspanLinkage(dataitem, data, index, rowspanDataItem);
              }
              if (this.sets.datas['nzRowspanfollow'].indexOf(element) >= 0) {

                for (let j = 0; j < this.sets.datas['nzRowspanfollow'].length; j++) {
                  const linkageelement = this.sets.datas['nzRowspanfollow'][j];
                  if (this.sets['datas']['showColumn'].indexOf(linkageelement) >= 0) {

                    if (res.indexOf(linkageelement) >= 0) {
                      // console.log("notcheckindex2", index, this.autoRowspanDataCopy.length, this.autoRowspanDataCopy)
                      // console.log("linkageelement", linkageelement)

                      const firstindex = this.autoRowspanDataCopy[index - 1][linkageelement]['firstindex']
                      this.autoRowspanDataCopy[firstindex][linkageelement]['rowspan']++;
                      //exportMergeData
                      this.exportMergeData[linkageelement][firstindex + ''] = this.autoRowspanDataCopy[firstindex][linkageelement]['rowspan'];
                      this.setRowspanDataItem(rowspanDataItem, linkageelement, 1, firstindex, false)
                    } else {
                      console.log("YieldTPYData", linkageelement, YieldTPYData)
                      this.setRowspanDataItem(rowspanDataItem, linkageelement, 1, index)

                    }

                  }
                }

              }

            } else {
              if (this.sets.datas.ColumnData[element]['rowspan']) {
                //非联合检测
                this.nzRowspan(dataitem, element, data, index, rowspanDataItem)
              } else {
                //无合并配置
                this.setRowspanDataItem(rowspanDataItem, element)

              }

            }

          } else {
            this.setRowspanDataItem(rowspanDataItem, element)
          }
        }

        /* 自动合并列计算 end**/

      }

      this.autoRowspanDataCopy.push(rowspanDataItem);
      res = [];
      if (index != data.data['list'].length - 1) {
        for (let j = 0; j < this.sets.datas['nzRowspanfollow'].length; j++) {
          const linkageelement = this.sets.datas['nzRowspanfollow'][j];
          if (this.sets['datas']['showColumn'].indexOf(linkageelement) >= 0) {
            if (dataitem[linkageelement] != data.data['list'][index + 1][linkageelement] && this.sets['datas']['virtualColumn2'].indexOf(linkageelement) < 0) {
              break;
            } else {
              res.push(linkageelement)
            }
          }
        }
      }
      if (planYieldData.used && res.indexOf(planYieldData.yield) < 0) {
        let countstandardtime = 0;
        let totaltime = 0, standardtime = 0;
        let finalyield = 0;
        let lastdata_firstindex = this.autoRowspanDataCopy[index][planYieldData.yield].firstindex;

        for (let k = lastdata_firstindex; k <= index; k++) {
          const countdata = data.data['list'][k];
          // console.log("countstandardtime", countstandardtime)
          if (countdata[planYieldData.standardhournum] === '0' || countdata[planYieldData.standardhournum] === '') {
            standardtime = 0;
          } else {
            standardtime = parseFloat(countdata[planYieldData.number]) / parseFloat(countdata[planYieldData.standardhournum]) + 0.5;
          }

          countdata[planYieldData.standardtime] = standardtime;
          countstandardtime = countstandardtime + standardtime;
          if (totaltime = 0) totaltime = countdata[planYieldData.totaltime];
        }
        // console.log("countstandardtime", countstandardtime)
        finalyield = countstandardtime / 11;
        for (let k = lastdata_firstindex; k <= index; k++) {
          data.data['list'][k][planYieldData.yield] = finalyield;
          data.data['list'][k][planYieldData.yield] = finalyield;
        }
      }
      if (YieldTPYData.used && notcheckindex != index && res.indexOf(YieldTPYData.date) < 0) {

        let addData = JSON.parse(JSON.stringify(data.data['list'][index]))
        let lastdata_firstindex = this.autoRowspanDataCopy[index][YieldTPYData.date].firstindex;
        let output = 0, input = 0, yieldp = 1;

        for (let k = lastdata_firstindex; k <= index; k++) {
          const countdata = data.data['list'][k];
          output = output + countdata[YieldTPYData.output];
          input = input + countdata[YieldTPYData.input];
          yieldp = yieldp * countdata[YieldTPYData.yield];
          console.log("output", output, input, yieldp)
        }
        addData[YieldTPYData.output] = output
        addData[YieldTPYData.input] = input
        addData[YieldTPYData.yield] = yieldp
        addData[YieldTPYData.name] = "TPY";
        data.data['list'].splice(index + 1, 0, addData);
        notcheckindex = index + 1;
        res = [];
        for (let j = 0; j < this.sets.datas['nzRowspanfollow'].length; j++) {
          const linkageelement = this.sets.datas['nzRowspanfollow'][j];
          if (this.sets['datas']['showColumn'].indexOf(linkageelement) >= 0) {
            if (dataitem[linkageelement] != data.data['list'][index + 1][linkageelement] && this.sets['datas']['virtualColumn2'].indexOf(linkageelement) < 0) {
              break;
            } else {
              res.push(linkageelement)
            }
          }
        }
      }

    }
    //导出渲染
    if (isExport) {
      this.checkColumn(checkResult, data.data['list']);
      // console.log('导出渲染', checkResult)
      //获取需要渲染的字段
      let needColumns = []
      this.sets.datas.showColumn.forEach(column => {
        const styles = this.sets.datas.ColumnData[column]['style'];
        if (styles.length > 0) {
          for (let i = 0; i < styles.length; i++) {
            const style = styles[i];
            if (style.styles.change !== '') {
              needColumns.push(column)
              break;
            }
          }
        }
      });

      const length = data.data['list'].length;
      // console.log('导出渲染-needColumns', needColumns,length)
      for (let index = 0; index < length; index++) {
        const element = data.data['list'][index];
        // if (checkResult[index][])
        needColumns.forEach(changeColumn => {
          if (checkResult[index][changeColumn]['change'][0] !== '@null') {
            element[changeColumn] = checkResult[index][changeColumn]['change'][0] + element[changeColumn] + checkResult[index][changeColumn]['change'][0]
          } else {
            element[changeColumn] = checkResult[index][changeColumn]['change'][1]
          }
          // console.log('导出渲染', index,changeColumn,element[changeColumn])
        });

      }
    }
    return data;
  }
  searchData(reset: boolean = false, searchMap?, status = { blockid: this.blockid, eventName: 'tableSearch', statuName: 'search' }, searchSets = {}) {
    this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName);
    this.loading = true;
    if (reset) {
      this.pageIndex = 1;
    }
    console.log('初始searchMap', searchMap)
    searchMap = this.getSearchMap(searchMap);
    this.getSortMap();

    console.log("this.tableSort:" + JSON.stringify(this.tableSort));


    let bodys = {
      "tableColumn": this.sets['datas']['searchColumn'],
      "tableName": this.sets['datas']['nzTableName'],
      "pageSize": this.sets['styles']['nzPageSize'],
      "nowPage": this.pageIndex,
      "tableSort": this.tableSort,
      "searchMap": searchMap,
      deleteFlag: []
    }
    console.log('nzIsDelete', this.sets.datas.nzIsDelete)
    if (this.sets.datas.sysFields['isDelete'] !== "") {
      if (this.sets.datas.nzIsDelete) {
        bodys['deleteFlag'] = [
          {
            "name": this.sets['datas']['sysFields']['isDelete'],
            "value": "0"
          }
        ]
      }
    }
    if (this.sets.datas.nzNeedOrganize == true) {
      bodys['engineMap'] = {
        "organize": [
          {
            "name": "organizeField",
            "value": this.sets.datas.sysFields['createUser']
          }
        ]
      }
    } else {
      bodys['engineMap'] = {}
    }
    console.log("searchMastColumn", this.sets.datas.searchMastColumn);
    for (let index = 0; index < this.sets.datas.searchMastColumn.length; index++) {
      const mastColumn = this.sets.datas.searchMastColumn[index];
      if (!bodys.searchMap[mastColumn]) {
        this.message.create('error', '缺少查询条件:' + this.sets.datas.ColumnData[mastColumn]['Relname']);
        this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName, 1);
        this.loading = false;
        return;
      }
    }

    // this.optionservice.postHttpAllUrl("http://localhost:8080/plancompletion/tableData001168", bodys).subscribe(
    if (this.sets.datas.jichengRightId) {
      this.setService.events[this.sets.datas.jichengRightId].emit({
        type: "bomData",
        datas: { bomData: [] }
      });
    }
    console.log("表格body", bodys, "\n" + JSON.stringify(bodys));
    this.optionservice.postHttp(this.httpUrls.tableData.url, bodys).subscribe(
      (data: any) => {
        this.autoRowspanData = [];

        console.log("表格data:", data, '\n' + JSON.stringify(data));
        this.setService.setPublicStatus(status.blockid, status.eventName, status.statuName, 1);

        //渲染准备
        this.checkResult = [];
        console.log("showColumn:" + JSON.stringify(this.sets['datas']['showColumn']));

        // nzCustom 数据设置
        this.setNzCustomData(data);
        this.getExportMergeDataByHead();
        data = this.dealVirtualColumn(data, this.checkResult);

        this.autoRowspanData = [...this.autoRowspanDataCopy];

        console.log("autoRowspanData", this.autoRowspanData);
        this.displayData = data.data['list'];
        if (this.sets.datas.jichengRightId) {
          this.setService.events[this.sets.datas.jichengRightId].emit({
            type: "bomData",
            datas: { bomData: data.data['list'] }
          });
        }




        //工作流查询
        console.log("this.sets.datas.nzVirtual", this.sets.datas.nzVirtual);
        if (this.sets.datas.nzVirtual.indexOf('workflow') >= 0) {
          this.displayData.forEach(element => {
            let workflowbody = {
              "csysWorkflowRunTable": this.sets.datas.nzTableName,
              "csysWorkflowRunTableVal": element[this.sets.datas.sysFields['primaryKeys'][0]],
            }

            console.log("workflowlistCondition" + JSON.stringify(workflowbody))
            this.optionservice.postHttp(this.httpUrls.workflowrunList.url, workflowbody).subscribe(
              (data2: any) => {
                console.log("listCondition！！！" + JSON.stringify(data2.data))
                element['workflow_id'] = this.sets.datas.nzVirtualData['workflow']['datas']['workflow_id']
                if (data2.data.list.length == 0) {
                  element['workflow_flowpointTransferId'] = ""
                  element['workflow_flowpointCurrentName'] = '无';
                  element['workflow_flowpointCurrentId'] = ""
                  element['workflow_runId'] = ""
                  element['workflow_status'] = "none"

                } else {

                  element['workflow_id'] = data2.data.list[0].csysWorkflowId
                  element['workflow_flowpointTransferId'] = data2.data.list[0].csysPotTrsId
                  element['workflow_flowpointCurrentName'] = data2.data.list[0].csysPotName
                  element['workflow_flowpointCurrentId'] = data2.data.list[0].csysPotId
                  element['workflow_runId'] = data2.data.list[0].csysWorkflowRunId
                  element['workflow_status'] = data2.data.list[0].csysWorkflowRunState

                }
                console.log("newelement" + JSON.stringify(element))
              });
          });
        }
        // this.groupResult = data.data['list'].groupResult;
        this.nzTotal = data.data['total'];
        //页脚设置
        let needFooter = {};

        if (this.sets['styles']['nzShowCheckbox'] == true) {
          this.footer['sucuCheckBox'] = this.sets['styles']['footerName'];
          this.alreadySet = true;
        } else if (this.sets['styles']['nzOperations']['nzOperationsPosition'] == 'front' && this.sets['styles']['nzOperations']['nzOperationsGroup'].length > 0) {
          this.footer['sucuOperations'] = this.sets['styles']['footerName'];
          this.alreadySet = true;
        }
        this.sets['datas']['showColumn'].forEach(element => {
          this.footer[element] = '';
          if (this.sets['datas']['ColumnData'][element]['footer'] != '') {
            this.isNeedFooter = true;
            needFooter[element] = this.sets['datas']['ColumnData'][element]['footer'];
          }
        });
        //图片数据处理
        let needPicTansfer = []
        this.sets['datas']['showColumn'].forEach(element => {

          if (this.sets['datas']['ColumnData'][element]['type'] == 'image') {
            needPicTansfer.push(element);
          }
        });

        let count = 0;
        this.displayData.forEach(dataelement => {

          for (const key in needFooter) {
            if (needFooter.hasOwnProperty(key)) {
              const element = needFooter[key];
              switch (element) {
                case 'sum':
                  if (this.footer[key] == '') this.footer[key] = 0;
                  // console.log("sum:" + this.footer[key] + "," + Number(dataelement[key]));
                  this.footer[key] = this.footer[key] + Number(dataelement[key]);
                  break;
                case 'avg':
                  if (this.footer[key] == '') this.footer[key] = 0;
                  this.footer[key] = (this.footer[key] * count + Number(dataelement[key])) / (count + 1);
                  count = count + 1;
                  break;
                case 'min':
                  if (this.footer[key] == '') this.footer[key] = dataelement[key];
                  this.footer[key] = min(this.footer[key], dataelement[key]);
                  break;
                case 'max':
                  if (this.footer[key] == '') this.footer[key] = Number(dataelement[key]);
                  this.footer[key] = this.footer[key] >= dataelement[key] ? this.footer[key] : dataelement[key];
                  break;
                case 'count':
                  if (this.footer[key] == '') this.footer[key] = 0;
                  this.footer[key] = this.footer[key] + 1;

                  break;

                default:
                  break;
              }
            }
          }

          //将图片数据进行装换
          needPicTansfer.forEach(picElement => {
            if (dataelement[picElement] != "")
              dataelement[picElement] = JSON.parse(dataelement[picElement]);

          });

          dataelement['checked'] = false;
          dataelement['disabled'] = false;

        });
        if (!this.alreadySet) {
          this.alreadySet = true;
          this.footer[this.sets['datas']['showColumn'][0]] = this.sets['styles']['footerName'];
        }
        this.isEdit = {};
        this.isRowEdit = {};
        this.columnStatu = {};
        this.allChecked = false;
        this.indeterminate = false;
        this.checkColumn(this.checkResult, this.displayData);
        //
        if (searchSets['checkall']) {
          this.checkAll(true);
        }

        this.loading = false;

      }
    );

    //数据刷新后，清除pageservice勾选数据

    this.pageService.pageBlockDatas[this.blockid]['checkValue'] = [];


  }


  setRowspanDataItem(rowspanDataItem, name, rowspan = 1, firstindex = 0, show = true) {
    rowspanDataItem[name] = {
      rowspan: rowspan,
      firstindex: firstindex,
      show: show
    }
  }
  /**
   * 普通合并
   * @param dataitem 当前行数据
   * @param element 字段名
   * @param data 所有数据
   * @param index 当前行号
   * @param rowspanDataItem 本行合并配置
   */
  nzRowspan(dataitem, element, data, index, rowspanDataItem) {
    if (dataitem[element] !== '' && dataitem[element] === data.data['list'][index - 1][element]) {

      const firstindex = this.autoRowspanDataCopy[index - 1][element]['firstindex']
      this.autoRowspanDataCopy[firstindex][element]['rowspan']++;
      this.exportMergeData[element][firstindex + ''] = this.autoRowspanDataCopy[firstindex][element]['rowspan'];
      this.setRowspanDataItem(rowspanDataItem, element, 1, firstindex, false)

      // rowspanDataItem[element] = {
      //   rowspan: 1,
      //   firstindex: firstindex,
      //   show: false
      // }
    } else {
      this.setRowspanDataItem(rowspanDataItem, element, 1, index)
      // rowspanDataItem[element] = {
      //   rowspan: 1,
      //   firstindex: index,
      //   show: true
      // }

    }
  }
  /**
   * 联合合并逻辑
   * @param dataitem 当前行数据
   * @param data 所有数据
   * @param index 当前行号
   * @param rowspanDataItem 本行合并配置
   */
  nzRowspanLinkage(dataitem, data, index, rowspanDataItem) {

    let linkcheck = true;
    //判断每个字段的值和上一个行是否都相等
    this.sets.datas['nzRowspanLinkage'].forEach(linkageelement => {
      if (this.sets['datas']['showColumn'].indexOf(linkageelement) >= 0) {
        // 1是否相等，2如果开启自动合并，则不管是否相等，都合并
        if (dataitem[linkageelement] != data.data['list'][index - 1][linkageelement] && !this.sets.datas.ColumnData[linkageelement]['rowspan']) {
          linkcheck = false;
        }
      }
    });
    this.sets.datas['nzRowspanLinkage'].forEach(linkageelement => {
      if (this.sets['datas']['showColumn'].indexOf(linkageelement) >= 0) {
        if (linkcheck) {
          const firstindex = this.autoRowspanDataCopy[index - 1][linkageelement]['firstindex']
          this.autoRowspanDataCopy[firstindex][linkageelement]['rowspan']++;
          //exportMergeData
          this.exportMergeData[linkageelement][firstindex + ''] = this.autoRowspanDataCopy[firstindex][linkageelement]['rowspan'];
          this.setRowspanDataItem(rowspanDataItem, linkageelement, 1, firstindex, false)
        } else {
          this.setRowspanDataItem(rowspanDataItem, linkageelement, 1, index)

        }
      }

    });
  }
  nzRowspanfollow() {

  }
  //排序
  tableSort = [];
  sort(sort: { key: string, value: string }): void {
    console.log(sort.key + "," + sort.value);
    if (sort.value == null) {
      this.tableSort = [];
    } else {
      this.tableSort = [{
        "name": "create_time",
        "value": "desc"
      }];
      this.tableSort[0]['name'] = sort.key;
      if (sort.value.startsWith('desc')) {
        this.tableSort[0]['value'] = 'desc';
      } else if (sort.value.startsWith('asc')) {
        this.tableSort[0]['value'] = 'asc';
      }

    }
    this.searchData();


  }
  //筛选

  groupResult = [{
    "value": "gry",
    "text": "gry"
  },
  {
    "value": "tty",
    "text": "tty"
  }
  ];
  searchValue = {};
  searchMap = {};


  filter(field, event) {
    // console.log("event:" + JSON.stringify(event));
    if (event.length > 0) {
      this.searchMap[field] = [];

      event.forEach(element => {
        this.searchMap[field].push(
          {
            "name": "=",
            "value1": element
          }
        )
      });
    } else {
      delete this.searchMap[field];
    }

    this.searchData();
    // console.log("event:" + JSON.stringify(this.searchMap));

  }
  search(field) {//暂时无用
    this.searchMap = [];
    if (this.searchValue[field] != "") {
      // console.log("json:" + JSON.stringify(this.sets['datas']['ColumnData'][field]));
      this.searchMap = [{
        "name": field,
        "value": [
          {
            "name": this.sets['datas']['ColumnData'][field]['searchType'],
            "value1": this.searchValue[field]
          }
        ]
      }];

    }
    this.searchData();

  }
  //操作组事件
  myContext;
  moreOperations = [];
  operationClick(type, index, page?) {
    // console.log("operationClick:" + type + "," + index);


    switch (type) {

      case "删除":

        this.deleteOne(index)
        break;

      case "编辑-本行":
        this.editOneStart(index);
        break;

      case "跳转":
        if (page.nzJumpType === 'setValue') {
          let checkedList = this.displayData.filter(value => value.checked);
          if (checkedList.length === 1) {

            page['nzSenceJson'].forEach(element => {

              checkedList.forEach(checkelement => {
                if (element.blockid !== undefined && element.blockid !== '')
                  this.setService.sendEvent(element.blockid, "linkagesetValue", { value: checkelement[element['columnName']] })
              });



            });

          } else {
            this.modalService.info({
              nzTitle: "提示",
              nzContent: "请勾选一条记录"
            });
          }
          return;
        }
        if (page.nzJumpType === 'closeValue') {
          this.checkAll(false);

          //选中当前选中行
          this.displayData[index].checked = true;
          this.refreshStatus();
          let checkedList = this.displayData.filter(value => value.checked);
          let data = {};
          if (checkedList.length === 1) {

            page['nzSenceJson'].forEach(element => {

              checkedList.forEach(checkelement => {
                data[element.virtualName] = checkelement[element['columnName']];
              });
            });
            console.log("关闭", this.setService.pageDatas['table_modal']['acceptBlockId'], data)
            this.setService.sendEvent(this.setService.pageDatas['table_modal']['acceptBlockId'], "setValues", data);
            this.layoutService.isVisible = false;
          } else {
            this.modalService.info({
              nzTitle: "提示",
              nzContent: "请勾选一条记录"
            });
          }
          return;
        }
        if (!this.static) {//配置环境

          this.modalService.info({
            nzTitle: "提示",
            nzContent: "请前往生产环境测试"
          });

        } else {
          console.log("编辑数据", page)
          console.log("编辑行数", index)
          let checkedList = this.displayData[index];
          console.log("记录", checkedList);
          //组装场景值数据
          let queryParams = {};

          page['nzSenceJson'].forEach(element => {
            //当前场景值字段
            console.log("场景值字段", element)

            let sceneitem = "";

            console.log("遍历数据", checkedList)
            console.log("遍历数据-->", checkedList[element['columnName']])
            sceneitem = sceneitem + checkedList[element['columnName']] + ",";


            sceneitem = sceneitem.substring(0, sceneitem.length - 1);

            queryParams[element['virtualName']] = sceneitem;

          });

          console.log("场景值组装完成", queryParams)


          const datas = {
            "type": page.nzJumpType,
            "mode": page.nzJumpMode,
            "nzSenceJson": page.nzSenceJson,
            "pageType": page.nzJumpPageType,
            "pageRoute": page.nzJumpPage,
            "modalTitle": page.nzJumpModalTitle,
            "modalWidth": page.nzJumpModalWidth
          }

          this.goRouter(datas, queryParams);


        }





        break;


    }



  }
  //编辑单行
  editfirstdata = {};
  editOneStart(index) {
    this.isRowEdit[index] = true;
    for (const key in this.displayData[index]) {
      if (this.displayData[index].hasOwnProperty(key)) {
        const element = this.displayData[index][key];
        this.isEdit[index + "-" + key] = false;
        // this.editfirstdata[index]=JSON.parse(JSON.stringify(this.displayData[index]))
      }
    }
  }
  cancelEdit(index): void {
    this.isRowEdit[index] = false;
    // this.displayData[index]=this.editfirstdata[index];
    this.searchData();
  }

  saveEdit(index): void {
    this.updateMap = [];
    this.sets['datas'].showColumn.filter(value => this.sets['datas']['ColumnData'][value]['attribute'] == '0').forEach(element => {
      this.updateMap.push({
        "name": element,
        "value": this.displayData[index][element]
      });
    });
    this.updateByUpdateMap(index, this.updateMap, index, true, "saveEdit");

  }

  //删除单行
  deleteOne(index) {
    let list = [this.displayData[index]];
    this.delete(list);
  }


  //===通用方法
  //删除
  async delete(checkedList) {
    console.log("删除2：" + checkedList.length)
    let bodys = [];
    let primaryMap = [];
    let res: any = {};
    if (this.sets.datas.nzProcedure.nzProcedureIsNeed) {
      this.pageService.pageBlockDatas[this.blockid]['checkValue'] = checkedList;
      res = await this.methodsService.procedure(this, { url: this.httpUrls.dynamicProcedure.url, returnType: 'default' })
      console.log('delete-res', res)
      if (res.CSYS_RETURN === 'fail' || res.CSYS_DELETE === 'stop') {
        console.log('delete-stop', res)
        if (res.CSYS_DELETE === 'stop') this.searchData();
        return;
      }
    }

    console.log('delete-do', res)
    for (let index = 0; index < checkedList.length; index++) {
      const element = checkedList[index];
      console.log('delete', element)
      primaryMap = [];
      this.sets['datas']['sysFields']['primaryKeys'].forEach(primaryKey => {
        primaryMap.push({
          "name": primaryKey,
          "value": element[primaryKey]
        });
      });
      let sysLogData = [];
      try {
        if (this.sets.datas.nzSysLog.length > 0) {
          sysLogData = JSON.parse(JSON.stringify(this.sets.datas.nzSysLog));
        }
      } catch (error) {

      }
      bodys.push({
        "tableName": this.sets['datas']['nzTableName'],
        "deleteFlag": this.sets['datas']['sysFields']['isDelete'],
        "primaryMap": primaryMap,
        "engineMap": {},
        logData: sysLogData
      });
    }
    console.log("delete-bodys:" + JSON.stringify(bodys));
    this.optionservice.postHttp(this.httpUrls.logicalDeleteData.url, bodys).subscribe(
      (data: any) => {
        // console.log(JSON.stringify(data));
        this.searchData();
        if (typeof data.extraData[0] != 'undefined') {
          if (typeof data.extraData[0]['CSYS_RETURN'] != 'undefined') {
            this.notification.create(
              data.extraData[0]['CSYS_RETURN'],
              data.extraData[0]['CSYS_RETURN'],
              data.extraData[0]['CSYS_INFO']
            );

          } else {
            this.message.create('success', `处理成功`);
          }
        } else {
          this.message.create('success', `处理成功`);
        }

        console.log("业务logData", JSON.stringify(data['logData']));
        // if (typeof data['logData'] != 'undefined' && typeof data['logData']['drawer'] != 'undefined') {
        //   this.pageService.sendLogs(sets.datas.nzForm.nzLog, data.logData.drawer, sets.datas.nzForm.nzLogSet);
        // }
      }
    );

  }
  //更新数据
  updateByUpdateMap(key: string, updateMap, index: string, isrefresh: boolean, otherEventType?) {
    this.primaryMap = [];
    this.sets['datas']['sysFields']['primaryKeys'].forEach(element => {
      this.primaryMap.push({
        "name": element,
        "value": this.displayData[index][element]
      })
    });
    // console.log("primaryKeys:" + JSON.stringify(this.sets['datas']['sysFields']['primaryKeys']));
    // console.log("primaryMap:" + JSON.stringify(this.primaryMap));
    const bodys = {
      "tableName": this.sets['datas']['nzTableName'],
      "updateMap": updateMap,
      "primaryMap": this.primaryMap,
      "engineMap": {}
    }
    console.log("bodys-updateByUpdateMap", bodys)
    this.optionservice.putHttp(this.httpUrls.tableData.url, bodys).subscribe(
      (data: any) => {
        console.log('res-updateByUpdateMap', JSON.stringify(data));
        if (otherEventType == "finishEdit") {
          this.isEdit[index + "-" + key] = false;
          this.isSpinning = false;
        }
        else if (otherEventType == "saveEdit") {
          this.isRowEdit[key] = false;
        }
        if (isrefresh) {
          this.searchData();
        }
      }
    );

  }
  updateOneFieldDate(key: string, value: string, index: string, isrefresh: boolean, otherEventType?) {
    this.updateMap = [];
    this.updateMap.push({
      "name": key,
      "value": value
    });
    this.updateByUpdateMap(key, this.updateMap, index, isrefresh, otherEventType);
  }
  conditions = [{
    condition: "",
    style: ""
  }];
  testIcon(styles, indexRow, Column) {
    if (typeof styles['icon'] != 'undefined') {
      this.columnStatu[indexRow + '-' + Column] = styles['icon'];
    }
  }
  // {
  //   [key: string]: {
  //     result: boolean,
  //     color: string,
  //     icon: string,
  //     change: any
  //   }
  // }
  checkResult = []
  exportCheckResult = []
  events = {};
  checkColumn(checkResult, displayData) {
    for (const key in this.events) {
      if (this.events.hasOwnProperty(key)) {
        this.events[key].unsubscribe();
      }
    }
    let dynamicSql = {}
    console.log("checkColumn:");
    this.sets.datas.showColumn.forEach(column => {
      const style = this.sets.datas.ColumnData[column]['style'];
      if (style.length > 0) {
        for (let index = 0; index < displayData.length; index++) {
          checkResult[index][column] = {
            result: false,
            color: '',
            icon: '',
            change: ['', ''],
            styles: []
          }
          const row = displayData[index];

          let value = row[column];
          for (let styleIndex = 0; styleIndex < style.length; styleIndex++) {
            const element = style[styleIndex];
            checkResult[index][column]['styles'].splice(styleIndex, 0, {
              end: false,
              results: [],
              childResults: [],
            });
            const styles = element.styles, conditions = element.conditions
            let result = false;
            if (element.type == 'reg') {
              //正则验证
              const reg = new RegExp(conditions.reg);
              result = reg.test(value);
              this.dealResult(result, styles, index, column, checkResult)
            } else {
              //表达式验证
              if (conditions.operator.length == 0) {
                result = true;
                this.dealResult(result, styles, index, column, checkResult)
              } else {
                //大条件
                for (let i = 0; i < conditions.operator.length; i++) {
                  const condition = conditions.operator[i];
                  checkResult[index][column]['styles'][styleIndex]['results'].splice(i, 0, false);
                  checkResult[index][column]['styles'][styleIndex]['childResults'].splice(i, 0, []);
                  //子条件
                  for (let j = 0; j < condition.length; j++) {
                    const conditionChild = condition[j];
                    checkResult[index][column]['styles'][styleIndex]['childResults'][i].splice(j, 0, false);
                    //取值
                    let compareValue = '';
                    if (conditionChild.dynamic) {
                      const id = conditionChild.id;
                      if (typeof dynamicSql[id] == 'undefined') {
                        this.events[id] = new EventEmitter();
                        dynamicSql[id] = '@cy-wait'
                        //动态值
                        let body = {
                          // 
                          // "dynamicSql": 'select test001_id as value from t_test001 where test001_id=80',
                          "dynamicSql": this.jwtService.replaceUser(conditionChild.value).replace(new RegExp("@value@", "gm"), value),
                          "pageSize": 0,
                          "nowPage": 0,
                          "paramMap": [],
                          "tableSort": [],
                          "searchMap": {
                          }
                        }
                        this.optionservice.postHttp(this.httpUrls.dynamicSql.url, body).subscribe(
                          (data: any) => {
                            dynamicSql[id] = data.data.list[0]['VALUE'];
                            compareValue = dynamicSql[id]
                            //比对
                            this.switchValue(value, compareValue, conditionChild, styleIndex, index, column, i, j, conditions, styles, checkResult);
                            this.events[id].emit('end')
                          })
                      } else if (dynamicSql[id] == '@cy-wait') {
                        this.events[id].subscribe(
                          data => {
                            compareValue = dynamicSql[id]
                            this.switchValue(value, compareValue, conditionChild, styleIndex, index, column, i, j, conditions, styles, checkResult);
                          }
                        )

                      }
                      else {
                        compareValue = dynamicSql[id]
                        this.switchValue(value, compareValue, conditionChild, styleIndex, index, column, i, j, conditions, styles, checkResult);

                      }

                    } else {
                      compareValue = conditionChild.value;
                      //比对
                      this.switchValue(value, compareValue, conditionChild, styleIndex, index, column, i, j, conditions, styles, checkResult);
                    }

                  }
                }
                checkResult[index][column]['styles'][styleIndex]['end'] = true;
                result = this.finalTest(styleIndex, index, column, conditions, checkResult);
                this.dealResult(result, styles, index, column, checkResult)

              }


            }


          }

        }
      }
    });
  }
  dealResult(result, styles, index, column, checkResult) {
    if (result) {
      let change = (styles.change + '').split('@value');
      checkResult[index][column]['result'] = result;
      checkResult[index][column]['color'] = styles.color;
      checkResult[index][column]['icon'] = styles.icon;
      checkResult[index][column]['change'] = [change[0], (change.length > 1) ? change[1] : ''];
    }
  }
  finalTest(styleIndex, index, column, conditions, checkResult): boolean {
    //最终测试
    let lastBoolean = false, finalboolean = false;
    for (let i = 0; i < checkResult[index][column]['styles'][styleIndex]['childResults'].length; i++) {
      const bigResults = checkResult[index][column]['styles'][styleIndex]['childResults'][i];
      for (let j = 0; j < bigResults.length; j++) {
        const singleResults = bigResults[j];
        if (j == 0) {
          lastBoolean = singleResults;
        } else {
          const link = conditions.operator[i][j]['link'];
          // console.log("link:" + link);
          if (link == '&&') {
            lastBoolean = (singleResults && lastBoolean);
          } else {
            lastBoolean = (singleResults || lastBoolean);
          }
        }
        checkResult[index][column]['styles'][styleIndex]['results'][i] = lastBoolean;
      }
      //一个计算完毕'(...)' && ...
      if (i > 0) {
        let biglink = conditions.operator[i][0]['link'];
        if (biglink == '&&') {
          finalboolean = (finalboolean && checkResult[index][column]['styles'][styleIndex]['results'][i]);
        } else {
          finalboolean = (finalboolean || checkResult[index][column]['styles'][styleIndex]['results'][i]);
        }
      } else {
        finalboolean = checkResult[index][column]['styles'][styleIndex]['results'][i];
      }
      // console.log("finalboolean:" + finalboolean);

    }
    return finalboolean;
  }
  switchValue(value, compareValue, conditionChild, styleIndex, index, column, i, j, conditions, styles, checkResult) {
    switch (conditionChild.operator) {
      case "=":
        if (compareValue == value)
          checkResult[index][column]['styles'][styleIndex]['childResults'][i][j] = true
        break;
      case "!=":
        if (compareValue != value)
          checkResult[index][column]['styles'][styleIndex]['childResults'][i][j] = true
        break;
      case "<":
        if (value < compareValue)
          checkResult[index][column]['styles'][styleIndex]['childResults'][i][j] = true
        break;
      case ">":
        if (value > compareValue)
          checkResult[index][column]['styles'][styleIndex]['childResults'][i][j] = true
        break;
      case "<=":
        if (value <= compareValue)
          checkResult[index][column]['styles'][styleIndex]['childResults'][i][j] = true
        break;
      case ">=":
        if (value >= compareValue)
          checkResult[index][column]['styles'][styleIndex]['childResults'][i][j] = true
        break;
      default:
        break;
    }
    if (checkResult[index][column]['styles'][styleIndex]['end'] == true) {
      let result = this.finalTest(styleIndex, index, column, conditions, checkResult)
      this.dealResult(result, styles, index, column, checkResult)
    }
  }
  textstyle(Column, indexRow): string {
    let res;
    let data = this.displayData[indexRow][Column];
    let style = this.sets['datas']['ColumnData'][Column]['style'];
    //  console.log("style.length:" + style.length);
    if (style.length > 0) {
      // console.log(index+"style:" + JSON.stringify(style));
      // let conditions, styles, type, icon;
      style.forEach(element => {
        const type = element.type, styles = element.styles, conditions = element.conditions
        // console.log("style.type:" + style.type);
        if (style.type == 'reg') {
          //正则验证
          const reg = conditions.reg;
          // console.log(reg+"reg:" + reg.test(data));
        } else {

        }
      });

    } else {
      return null;
    }


  }

  picPreview(pic) {

    this.previewImage = pic;
    this.picIsVisible = true;
  }
  //================导出=====================

  export2() {
    const myObservable = observableOf(1);
    const workbook = new Excel.Workbook();
    const exportAfterGetData = {
      next: x => {

        workbook.xlsx.writeBuffer().then((data) => {
          console.log("writeBuffer", workbook)
          let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          fs.saveAs(blob, this.generalPipe.transform(new Date(), 'date', 'yyyy-MM-dd HH:mm:ss') + '.xlsx');
          this.exporting = false;
          this.exportShow = false;
          this.setService.sendEvent(this.doExportBlockid, 'nzLoadingOk');
          this.message.create('success', `生成成功，请下载。`);
        })
      }
    };

    let url = 'http://172.16.8.107:8010/export/newExcelFile/20190827/Form20190815.xlsx'
    // url = 'http://localhost:4200/assets/img/Form20190814.xlsx'
    url = 'http://localhost:4200/assets/img/work.xlsx'
    console.log("url", url)
    this.optionservice.getFile(url).subscribe(
      (datas: any) => {
        console.log("data", datas)
        // let buffdata = new Uint8Array(datas)
        workbook.xlsx.load(datas)
          .then(function () {
            myObservable.subscribe(exportAfterGetData);
          });


      }
    );

  }
  exportShow = false;
  exporting = false;
  validateForm: FormGroup;
  myObservable = observableOf(1);
  exportMergeData = {};
  headIndex = {};
  /** 拆分数据 */
  breakData = {

  }
  initFrom() {
    this.validateForm = this.fb.group({
      dataSource: ['pageData'],
      maxNum: [5000],
      pageNumber: [1],
      virtualColumn: [true],
      customHead: [false],
      auto: [false],
      autoStop: [30],
      breakSheet: [[]],
      breakSheet1Show: [false],
      breakSheet2Show: [false],
      breakFile: [[]],
      breakFile1Show: [false],
      breakFile2Show: [false],
      zip: [false],
    });
  }
  exportData: any;
  secondData = {
    dataSource: 'pageData',
    maxNum: 5000,
    pageNumber: 1,
    virtualColumn: true,
    auto: false,
    autoStop: 30,
    customHead: false,
    breakSheet: [],
    breakSheet1Show: false,
    breakSheet2Show: false,
    breakFile: [],
    breakFile1Show: false,
    breakFile2Show: false,
    zip: false,
  };
  exportFirstOpen = true;
  frontExport() {

    this.secondData = {
      dataSource: 'pageData',
      maxNum: 5000,
      pageNumber: 1,
      virtualColumn: true,
      customHead: false,
      auto: false,
      autoStop: 30,
      breakSheet: [],
      breakSheet1Show: false,
      breakSheet2Show: false,
      breakFile: [],
      breakFile1Show: false,
      breakFile2Show: false,
      zip: false,
    };
    if (this.exportData.nzSecondSet) {
      if (this.exportFirstOpen && (this.exportData.nzDefault || this.exportData.nzSecondSetData.length !== '')) {
        this.setSecondData(this.exportData.nzSecondSetData);
        this.exportFirstOpen = false;
      }
      this.exportShow = true;
      return;
    } else {
      this.exporting = true;
      if (this.exportData.nzSecondSetData.length !== '') {
        try {
          const secondData = JSON.parse(this.exportData.nzSecondSetData);
          for (const key in secondData) {
            if (secondData.hasOwnProperty(key)) {
              this.secondData[key] = secondData[key];
            }
          }
          // console.log('secondData', this.secondData, this.exportData.nzSecondSetData)
        } catch (error) {
          console.error('secondData', error)

        }
      }
      this.doExport();
    }

  }
  secondExport() {
    // this.message.create('success', `生成成`);
    this.exporting = true;
    this.getSecondData();

    this.doExport();
  }
  getSecondData() {
    this.secondData['dataSource'] = this.validateForm.controls.dataSource.value;
    this.secondData['virtualColumn'] = this.validateForm.controls.virtualColumn.value;
    this.secondData['customHead'] = this.validateForm.controls.customHead.value;
    if (this.secondData['dataSource'] !== 'pageData') {
      this.secondData['auto'] = this.validateForm.controls.auto.value;
      this.secondData['autoStop'] = this.validateForm.controls.autoStop.value;
      this.secondData['pageNumber'] = this.validateForm.controls.pageNumber.value;
      this.secondData['maxNum'] = this.validateForm.controls.maxNum.value;
      this.secondData['breakSheet'] = this.validateForm.controls.breakSheet.value;
      this.secondData['breakSheet1Show'] = this.validateForm.controls.breakSheet1Show.value;
      this.secondData['breakSheet2Show'] = this.validateForm.controls.breakSheet2Show.value;
      this.secondData['breakFile'] = this.validateForm.controls.breakFile.value;
      this.secondData['breakFile1Show'] = this.validateForm.controls.breakFile1Show.value;
      this.secondData['breakFile2Show'] = this.validateForm.controls.breakFile2Show.value;
      this.secondData['zip'] = this.validateForm.controls.zip.value;
    }
    console.log('secondData', this.secondData)
  }
  changeAuto(event) {
    if (event) {
      this.validateForm.controls.maxNum.patchValue(1000);
      this.validateForm.controls.maxNum.disable();
    } else {
      this.validateForm.controls.maxNum.enable();
    }
  }
  setSecondData(dataString) {
    if (this.exportData.nzSecondSetData.length !== '') {
      try {
        const secondData = JSON.parse(dataString);
        for (const key in secondData) {
          switch (key) {
            case 'dataSource':
              this.validateForm.controls.dataSource.patchValue(secondData[key]);
              break;
            case 'virtualColumn':
              this.validateForm.controls.virtualColumn.patchValue(secondData[key]);
              break;
            case 'customHead':
              this.validateForm.controls.customHead.patchValue(secondData[key]);
              break;
            case 'maxNum':
              this.validateForm.controls.maxNum.patchValue(secondData[key]);
              break;
            case 'breakSheet':
              this.validateForm.controls.breakSheet.patchValue(secondData[key]);
              break;
            case 'breakSheet1Show':
              this.validateForm.controls.breakSheet1Show.patchValue(secondData[key]);
              break;
            case 'breakSheet2Show':
              this.validateForm.controls.breakSheet2Show.patchValue(secondData[key]);
              break;
            case 'breakFile':
              this.validateForm.controls.breakFile.patchValue(secondData[key]);
              break;
            case 'breakFile1Show':
              this.validateForm.controls.breakFile1Show.patchValue(secondData[key]);
              break;
            case 'breakFile2Show':
              this.validateForm.controls.breakFile2Show.patchValue(secondData[key]);
              break;
            case 'zip':
              this.validateForm.controls.zip.patchValue(secondData[key]);
              break;
            case 'auto':
              this.validateForm.controls.auto.patchValue(secondData[key]);
              break;
            case 'autoStop':
              this.validateForm.controls.autoStop.patchValue(secondData[key]);
              break;

            case 'pageNumber':
              this.validateForm.controls.pageNumber.patchValue(secondData[key]);
              break;
            default:
              break;
          }
        }
      } catch (error) {
      }
    }

  }
  onClick1_save(blockid) {
    this.getSecondData();
    this.setService.pzEvents[blockid].emit({
      type: 'onClick1_save',
      datas: JSON.stringify(this.secondData)
    })
  }
  onClick3_read() {

  }
  exportDataList = [];
  workBooks = [];
  workBooksJson: {
    [key: string]: {
      workbook: any;
      set: any;
    }
  } = {};
  sheetJson = {};


  zipExcel() {
    let zip: JSZip = new JSZip();
    const myObservable = observableOf(1);
    let fileOk = 0;
    const exportData = this.exportData
    // const setProgress=this.setProgress;
    const zipFile = {
      next: x => {
        console.log('fileOk', fileOk);
        if (fileOk === 0) {
          // console.log('开始压缩');
          // setProgress('文件生成',0);
          zip.generateAsync({ type: "blob" })
            .then(function (content) {
              // see FileSaver.js
              fs.saveAs(content, exportData.nzExportExcelName + ".zip");
              // setProgress('文件生成',1);
              myObservable.subscribe(spinOk);
            });
        }

      }
    };
    const spinOk = {
      next: x => {
        console.log('fileOk', fileOk);
        if (fileOk == 0) {
          this.exporting = false;
          this.exportShow = false;
          this.setService.sendEvent(this.doExportBlockid, 'nzLoadingOk');
          this.message.create('success', `生成成功，请下载。`);
        }

      }
    };
    let fileOkindex = 0;
    this.setProgress((this.secondData['zip'] && this.workBooks.length > 1) ? '文件压缩' : '文件生成', 0);
    for (let index = 0; index < this.workBooks.length; index++) {
      fileOk++;
      const workbookData = this.workBooks[index];
      workbookData.workbook.xlsx.writeBuffer().then((data) => {
        console.log("workbookData", index, fileOk, workbookData);
        let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        if (this.secondData['zip'] && this.workBooks.length > 1) {
          zip.file(exportData.nzExportExcelName + (workbookData.set.fileName != '' ? '-' : '') + workbookData.set.fileName + '.xlsx', blob);
          fileOk--;
          this.setProgress('文件压缩', (++fileOkindex) / this.workBooks.length);
          myObservable.subscribe(zipFile);
        } else {
          fs.saveAs(blob, exportData.nzExportExcelName + (workbookData.set.fileName != '' ? '-' : '') + workbookData.set.fileName + '.xlsx');
          this.setProgress('文件生成', 1);
          fileOk--;
          myObservable.subscribe(spinOk);
        }


      })
    }




  }
  getSheetName() {

  }
  makeWorkbook(set, head, workbook) {

    console.log("set['sheetdata']", set['sheetdata'])
    let sheetindx = 1;
    for (const sheetid in set['sheetdata']) {
      let oldSheetName = set['sheetdata'][sheetid]['sheetName'];
      let sheetName = set['sheetdata'][sheetid]['sheetName'];
      sheetindx++;
      if (set['sheetdata'].hasOwnProperty(sheetid)) {
        const data = set['sheetdata'][sheetid]['data'];
        if (sheetName == '' || sheetName.length > 30) {
          sheetName = this.exportData.nzSheetNameArray + sheetindx;
        }
        if (sheetName.length > 30) sheetName = 'sheet' + sheetindx;
        console.log("sheetName", sheetName)
        const exportMergeData = set['sheetdata'][sheetid]['exportMergeData'];
        let sheet = this.sheetJson[oldSheetName];
        console.log('sheet', sheet)
        if (!sheet) {
          sheet = workbook.getWorksheet(sheetName)
          if (!sheet) {
            sheet = workbook.addWorksheet(sheetName)
          }
          this.sheetJson[oldSheetName] = sheet;
        }
        // console.log('exportdata', data)
        if (data.length > 0) {
          //已处理数据 需要先头后格式
          sheet.columns = this.autoWidth(data[0], head);
        } else {
          this.message.create('error', `没有数据`);
          this.exporting = false;
          this.setService.sendEvent(this.doExportBlockid, 'nzLoadingOk');
          return;
        }
        console.log('columns', sheet.columns);
        // 特殊设置
        sheet.columns.forEach(element => {
          if (this.sets['datas']['ColumnData'][element.key]['type'] === 'virtualText') {
            element.key = this.sets['datas']['ColumnData'][element.key]['format'];
          }
        });
        console.log('columns2', sheet.columns, this.exportData.styles);

        sheet.addRows(data);

        //样式设置 
        const headHeight = 1;//表头 暂时只支持1层表头
        for (let index = 1; index <= sheet.rowCount; index++) {
          let styleName = 'bodyStyle'
          if (index <= headHeight) styleName = 'headStyle';
          for (const name in this.exportData.styles[styleName].control) {
            if (this.exportData.styles[styleName].control[name]) {
              if (name != 'border') {
                sheet.getRow(index)[name] = this.exportData.styles[styleName][name]
              } else {
                const row = sheet.getRow(index);
                row.eachCell((cell, rowNumber) => {
                  cell.border = this.exportData.styles[styleName][name]
                })
              }

            }
          }
        }
        // 自动筛选
        sheet.autoFilter = 'A1:' + this.indexToColName(head.length - 1) + '1';
        //合并设置
        console.log("合并数据", head, exportMergeData)
        // let headArr = []
        // head.forEach(element => {
        //   headArr.push(element.key)
        // });
        for (const name in exportMergeData) {
          if (typeof this.headIndex[name] != 'undefined' && this.sets.datas.ColumnData[name]['exportRowspan']) {
            for (const index in exportMergeData[name]) {
              const length = exportMergeData[name][index];
              const columnChar = this.indexToColName(this.headIndex[name]);
              const startIndex: number = parseInt(index) + 1 + headHeight;
              const endIndex: number = startIndex + length - 1;
              // console.log("mergeCells", name, columnChar + startIndex + ':' + columnChar + endIndex)
              sheet.mergeCells(columnChar + startIndex + ':' + columnChar + endIndex);
            }
          }

        }



      }

    }


  }

  formatHead = {

  }
  getFormatName(value, key) {
    if (typeof this.formatHead[key] != "undefined") {
      if (value != '') {
        return this.generalPipe.transform(value, this.formatHead[key].type, this.formatHead[key].format)
      }
    }
    return value;
  }
  doExportBlockid
  getFinalHead(search = false): void {
    this.headIndex = {};
    this.getExportMergeDataByHead(search);
    let head = this.getHead(this.exportHead);
    console.log("headIndex", this.headIndex);
    this.exportHead.forEach(header => {
      if (this.sets.datas.ColumnData[header.key]['type'] == 'date') {
        this.formatHead[header.key] = {
          type: this.sets.datas.ColumnData[header.key]['type'],
          format: this.sets['datas']['ColumnData'][header.key]['format']
        }
      }
      else if (this.sets.datas.ColumnData[header.key]['type'] == 'numerical') {
        this.formatHead[header.key] = {
          type: this.sets.datas.ColumnData[header.key]['type'],
          format: this.sets['datas']['ColumnData'][header.key]['format']
        }
      }
    });
    this.head = head;
  }
  head: any[] = [];
  doExport() {
    this.setService.sendEvent(this.doExportBlockid, 'nzLoading');
    this.exportCheckResult = [];
    this.workBooks = [];
    this.breakData = {}
    this.exportDataList = [];
    this.workBooksJson = {};
    this.sheetJson = {};
    this.exportMergeData = {};
    //获取数据后导出
    if (!this.getExportDataSub) {
      this.getExportDataSub = this.getExportData$.subscribe(data => {
        console.log('this.breakData', data.last, this.breakData)
        this.setProgress('文件构建', 0);
        let workBooknum = 0
        for (const key in this.breakData) {
          workBooknum++;
        }
        let workBookindex = 0;
        for (const key in this.breakData) {
          let workbook;
          if (!this.workBooksJson[key]) {
            workbook = new Excel.Workbook();
            let item = {
              workbook: workbook,
              set: this.breakData[key]
            }
            this.workBooksJson[key] = item;
            this.workBooks.push(item);
          } else {
            workbook = this.workBooksJson[key].workbook;
          }
          this.makeWorkbook(this.breakData[key], this.head, workbook);
          this.setProgress('文件构建', ++workBookindex / workBooknum);
        }
        console.log("this.workBooks", this.workBooks)
        if (data.last) {
          this.zipExcel();
        }
      });
    }
    //获取数据
    this.setProgress('获取数据', 0);
    if (this.secondData.dataSource === 'pageData') {
      this.getFinalHead();
      // this.exportDataList = [...this.displayData];
      this.breakData['f0'] = {
        fileName: '',
        sheetdata: {
          s0: {
            sheetName: '',
            data: this.dealExcelFormat([...JSON.parse(JSON.stringify(this.displayData))]),
            exportMergeData: JSON.parse(JSON.stringify(this.exportMergeData))
          }
        }
      }
      this.setProgress('获取数据', 1);
      this.getExportData$.next({
        last: true
      })
    } else {
      // for (let index = this.secondData['maxNum']; index <= this.secondData['maxNum'] + 10; index++) {
      // }
      if (!this.sets.datas.nzCustom.nzUsed) {
        this.getFinalHead();
      }
      this.getDataForExport(this.validateForm.get('pageNumber').value);

    }
  }
  /**
   * 获取导出数据
   * @param exportAfterGetData 
   */
  getDataForExport(nowPage) {
    let searchMap = this.getSearchMapBylayout(this.exportData.layoutid);
    this.getSortMap();
    let bodys = {
      "tableColumn": this.sets['datas']['searchColumn'],
      "tableName": this.sets['datas']['nzTableName'],
      "pageSize": this.secondData['maxNum'],
      "nowPage": nowPage,
      "tableSort": this.tableSort,
      "searchMap": searchMap
    }
    if (this.sets.datas.sysFields['isDelete'].length == 0 || this.sets.datas.sysFields['isDelete'] == "") {
      bodys['deleteFlag'] = [];
    } else {
      bodys['deleteFlag'] = [
        {
          "name": this.sets['datas']['sysFields']['isDelete'],
          "value": "0"
        }
      ]
    }
    if (this.sets.datas.nzNeedOrganize == true) {
      bodys['engineMap'] = {
        "organize": [
          {
            "name": "organizeField",
            "value": this.sets.datas.sysFields['createUser']
          }
        ]
      }
    } else {
      bodys['engineMap'] = {}
    }
    // console.log("bodys:" + JSON.stringify(bodys));
    this.optionservice.postHttp(this.httpUrls.tableData.url, bodys).subscribe(
      // this.optionservice.postHttpAllUrl('http://172.16.8.106:81/cloudblock_lhoracle//plancompletion/tableData001168', bodys).subscribe(
      (data: any) => {

        // console.log("secondData:", this.secondData);
        // console.log("data:", data);
        // nzCustom 数据设置
        this.setProgress('获取数据', 1);
        this.message.info('一共' + data.data.pages + '页' + ',当前第' + bodys.nowPage + '页')
        // console.log("表格data:" + JSON.stringify(data), this.secondData['virtualColumn']);
        this.setNzCustomData(data);
        if (this.sets.datas.nzCustom.nzUsed) {
          this.getFinalHead();
        }
        if (this.secondData['breakSheet'].length > 0 || this.secondData['breakFile'].length > 0) {
          this.setProgress('数据分组中', 0);
          let index = 0;
          // this.breakData = {};
          data.data['list'].forEach(element => {

            let name1 = "", name2 = "", sheetname = "", filename = "";
            if (this.secondData['breakFile'].length == 0) {
              name1 = "f1f2"
            } else if (this.secondData['breakFile'].length == 1) {
              name1 = "f1" + element[this.secondData['breakFile'][0]] + "f2"

              filename = this.getFormatName(element[this.secondData['breakFile'][0]], this.secondData['breakFile'][0]);
            } else {
              name1 = "f1" + element[this.secondData['breakFile'][0]] + "f2" + element[this.secondData['breakFile'][1]]
              filename = this.getFormatName(element[this.secondData['breakFile'][0]], this.secondData['breakFile'][0]) + '-', this.getFormatName(element[this.secondData['breakFile'][1]], this.secondData['breakFile'][1]);
            }

            if (this.secondData['breakSheet'].length == 0) {
              name2 = "s1s2"
            } else if (this.secondData['breakSheet'].length == 1) {
              name2 = "s1" + element[this.secondData['breakSheet'][0]] + "s2";
              sheetname = this.getFormatName(element[this.secondData['breakSheet'][0]], this.secondData['breakSheet'][0]);

            } else {
              name2 = "s1" + element[this.secondData['breakSheet'][0]] + "s2" + element[this.secondData['breakSheet'][1]]
              sheetname = this.getFormatName(element[this.secondData['breakSheet'][0]], this.secondData['breakSheet'][0]) + "-" + this.getFormatName(element[this.secondData['breakSheet'][1]], this.secondData['breakSheet'][1]);
            }
            // console.log("element", JSON.stringify(element), name)
            if (typeof this.breakData[name1] == "undefined") {
              //创建文件
              this.breakData[name1 + ''] = {
                fileName: filename,
                sheetdata: {}
              }
            }
            if (typeof this.breakData[name1]['sheetdata'][name2] == "undefined") {
              //创建文件
              this.breakData[name1]['sheetdata'][name2] = {
                sheetName: sheetname,
                data: [],
                exportMergeData: {}
              }
            }
            this.breakData[name1]['sheetdata'][name2]['data'].push(element);
            this.setProgress('数据分组中', ++index / data.data['list'].length);
          });
          console.log("数据组合完毕", this.breakData, this.exportMergeData)
          //处理合并数据
          let sheetnum = 0;
          for (const fileid in this.breakData) {
            for (const sheetid in this.breakData[fileid]['sheetdata']) {
              sheetnum++;
            }
          }
          let sheetdealindex = 0;
          this.setProgress('数据处理', 0);
          const exportMergeData = JSON.parse(JSON.stringify(this.exportMergeData));
          for (const fileid in this.breakData) {
            const sheetdata = this.breakData[fileid]['sheetdata'];
            for (const sheetid in sheetdata) {
              // this.getExportMergeDataByHead(true);
              // 重置exportMergeData
              this.exportMergeData = JSON.parse(JSON.stringify(exportMergeData));
              console.log("sheetdata", sheetdata, sheetid)
              sheetdata[sheetid].data = this.dealExcelFormat(this.dealVirtualColumn(
                {
                  data: {
                    list: sheetdata[sheetid].data
                  }
                }, this.exportCheckResult, true
              ).data['list']);

              sheetdata[sheetid].exportMergeData = JSON.parse(JSON.stringify(this.exportMergeData));
              this.setProgress('数据处理', ++sheetdealindex / sheetnum);
            }
          }

          console.log("数据处理完毕", this.breakData)

        } else {
          this.setProgress('数据处理', 0);
          this.breakData['f0'] = {
            fileName: '',
            sheetdata: {
              s0: {
                sheetName: '',
                data: this.dealExcelFormat(this.dealVirtualColumn(data, this.exportCheckResult, true).data['list']),
                exportMergeData: {}
              }
            }
          }
          this.breakData['f0']['sheetdata']['s0']['exportMergeData'] = JSON.parse(JSON.stringify(this.exportMergeData));
          this.setProgress('数据处理', 1);
        }
        // this.exportDataList = this.dealVirtualColumn(data).data['list'];
        // data.data?.pages
        if (this.secondData.auto && nowPage < this.secondData.autoStop && nowPage < data.data.pages) {
          this.getExportData$.next({
            last: false
          })
          this.getDataForExport(nowPage + 1);
        } else {
          this.getExportData$.next({
            last: true
          })
        }

      },
      (err: any) => {
        this.message.create('error', `数据查询失败，请重试`);
        this.exporting = false;
        this.setService.sendEvent(this.doExportBlockid, 'nzLoadingOk');
      }
    );
  }

  autoWidth(data, exclehead) {
    //设置样式
    //设置样式-1自动宽度
    exclehead.forEach(element => {
      //先算表头长度
      if (element.header.length + 5 >= element.width) {
        element.width = element.header.length + 5;
      }
      //算内容长度
      if (data[element.key]) {
        if (data[element.key].length + 5 >= element.width) {
          element.width = data[element.key].length + 5;
        }
      }
    });
    return exclehead;
  }
  getExportMergeDataByHead(search = true) {
    this.exportHead = [];
    //checked检测
    let searchColumnList = [];
    this.sets.datas.searchColumn.forEach(element => {
      searchColumnList.push(element.name)
    });
    if (this.secondData['virtualColumn']) {
      // 导出虚拟字段
      this.sets['datas']['virtualColumn2'].forEach(element => {
        console.log('virtualColumn', 'searchColumnItem', element, this.sets['datas']['ColumnData'][element]);
        if (this.sets['datas']['ColumnData'][element]['type'] != "pop" && this.sets['datas']['ColumnData'][element]['isShow']) {
          searchColumnList.push(element);
        }

      });
    }


    if (this.secondData.dataSource === 'pageData' && search == false) {

    } else {
      this.exportMergeData = {};
      this.headIndex = {}
    }
    let index = 0;
    this.sets.datas.showColumn.forEach(element => {
      if (searchColumnList.includes(element) || this.sets.datas.ColumnData[element]['baseId'] === '0') {
        //简单表头，showColumn
        let item = {
          header: this.sets.datas.ColumnData[element]['Relname'],
          key: element,
          width: 10
        }

        this.exportHead.push(item);
        if (this.secondData.dataSource === 'pageData' && search == false) {

        } else {
          this.exportMergeData[element] = {};
          this.headIndex[element] = index++;
        }

      }

    });
  }
  exportHead = []
  exportHeadSelect = {}
  changeBreak() {
    this.exportHeadSelect = {}
    this.exportHead.forEach(head => {
      if (this.validateForm.controls.breakSheet.value.indexOf(head.key) >= 0 || this.validateForm.controls.breakFile.value.indexOf(head.key) >= 0) {
        this.exportHeadSelect[head.key] = true;
      }
    });
    console.log('this.exportHeadSelect', this.exportHeadSelect)
    console.log('this.exportHeadSelect', this.exportHeadSelect)
  }
  /**
   * 设置表头
   */
  getHead(header) {
    let exclehead = [...header];
    //根据拆分设置，移除表头
    console.log("exclehead", JSON.stringify(exclehead))
    for (let index = 0; index < exclehead.length; index++) {
      const head = exclehead[index];
      let breakindex: number = this.secondData['breakFile'].indexOf(head.key)
      if (breakindex >= 0 && !this.secondData['breakFile' + (breakindex + 1) + 'Show']) {
        exclehead.splice(index, 1);
        index--
      } else {
        breakindex = this.secondData['breakSheet'].indexOf(head.key);
        if (breakindex >= 0 && !this.secondData['breakSheet' + (breakindex + 1) + 'Show']) {
          exclehead.splice(index, 1);
          index--
        }
      }

    }
    console.log("exclehead2", JSON.stringify(exclehead))
    //设置样式
    //设置样式-1自动宽度
    this.headIndex = {};
    let index = 0;
    exclehead.forEach(element => {
      this.headIndex[element.key] = index++;
    });
    return exclehead;
  }

  indexToColName(index: number): string {
    if (index < 0) {
      return null;
    }
    let num = 65;// A的Unicode码
    let colName = "";
    do {
      if (colName.length > 0) {
        index--;
      }
      let remainder = index % 26;
      colName = String.fromCharCode(remainder + num) + colName;
      index = parseInt(((index - remainder) / 26) + '');
    } while (index > 0);
    return colName;
  }
  progressText = "进度打"
  nzPercent = 0;
  setProgress(text, num) {
    console.log("textnum", text, num)
    this.progressText = text
    this.nzPercent = Math.round(num * 100)
  }
  //================导出end==================

}
